import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe, DecimalPipe, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ObservableMedia, MediaChange } from '@angular/flex-layout';
import { MatSelectChange } from '@angular/material/select';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { first } from 'rxjs/operators/first';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { startWith } from 'rxjs/operators/startWith';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { empty } from 'rxjs/observable/empty';
import { zip } from 'rxjs/observable/zip';

import { isBefore } from 'date-fns';

import { ApproveRequestInfo } from '../ui/courseselectionpanel/courseselectionpanel.component';
import { TimelineStepInfo } from '../ui/timeline/timeline.component';

import {
    ApplicationService,
    CollegeAgreement,
    CollegeCourseInfo,
    CollegeDepartmentInfo,
    CollegeInfo,
    CollegeRecordNote,
    DesigneeRightsInfo,
    ProgramInfo,
    SchoolCounselorInfo,
    CourseChoice,
    StudentAgreementsStatus,
    StudentCollegeInfo,
    StudentInfo,
    AddStudentCollegeRecordReturn,
} from '../../services/application/application.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService, HttpMethod, DownloadFormat } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService, UserInfo } from '../../services/user/user.service';

import { AcceleratedDegreeProgramPipe } from '../../pipes/accelerateddegreeprogram.pipe';
import { CollegeTermPipe } from '../../pipes/collegeterm.pipe';
import { DualEnrollmentProgramPipe } from '../../pipes/dualenrollmentprogram.pipe';
import { ExtendedCollegeTermPipe } from '../../pipes/extendedcollegeterm.pipe';
import { FormStatusPipe } from '../../pipes/formstatus.pipe';
import { SchoolYearPipe } from '../../pipes/schoolyear.pipe';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
import { StudentProgramChange } from '../ui/studentcollegerecords/studentcollegerecords.component';

@Component({
    selector: 'app-requests-component',
    styleUrls: ['requests.component.css'],
    templateUrl: 'requests.component.html',
})
export class RequestsComponent implements OnInit, OnDestroy {
    private _subRelease: Subject<void> = new Subject<void>();

    Params_RecordID: number;
    Params_CollegeID: number;
    Params_SchoolYear: string;
    Params_StudentID: string;
    Params_Term: string;

    AcceleratedDegreeProgramChoice: number;
    AcceleratedDegreePrograms: ProgramInfo[];
    AgreementChecks: StudentAgreementsStatus;
    AvailableColleges: CollegeInfo[];
    CanAddTerms: boolean;
    CanBypassAdmin: boolean;
    ContactEmail: string;
    ContactPhone: string;
    Counselors: SchoolCounselorInfo[];
    CurrentSchoolYear: string;
    DesigneeCounselorRights: DesigneeRightsInfo[];
    DualEnrollmentProgramChoice: number;
    DualEnrollmentPrograms: ProgramInfo[];
    FilteredStudentCollegeInfo: StudentCollegeInfo[];
    HasSeenEarlyAdmissionsPopup: boolean;
    HasCompletedOrientation: boolean;
    LastSizeCode: string;
    PartialViewReady: boolean;
    PCSBAgreementText: string;
    PCSBAgreementDate: Date;
    PCSBAgreementConsentText: string;
    RequiredOrientationColleges: number[] = [2];
    RequiresOrientation: boolean;
    SelectedCollege: StudentCollegeInfo;
    SelectedCollegeCourses: CollegeCourseInfo[];
    SelectedCollegeDepartments: CollegeDepartmentInfo[];
    SelectedSchoolYear: string;
    SelectedStudent: StudentInfo;
    ShowAgreements: boolean;
    ShowTestHistory: boolean;
    SmallDisplay: boolean;
    Steps: TimelineStepInfo[];
    StudentCollegeInfo: StudentCollegeInfo[];
    StudentIDAtCollege: string;
    StudentSchedule: CourseChoice[];
    StudentScheduleNotes: CollegeRecordNote[];
    TimelineStep: number;
    User: UserInfo;

    constructor(
        private acceleratedDegreeProgramPipe: AcceleratedDegreeProgramPipe,
        private appService: ApplicationService,
        private collegeTermPipe: CollegeTermPipe,
        private datePipe: DatePipe,
        private decimalPipe: DecimalPipe,
        private dialogService: DialogService,
        private downloadService: DownloadService,
        private dualEnrollmentProgramPipe: DualEnrollmentProgramPipe,
        private errorService: ErrorService,
        private extendedCollegeTermPipe: ExtendedCollegeTermPipe,
        private formStatusPipe: FormStatusPipe,
        private location: Location,
        private route: ActivatedRoute,
        private mediaChange: ObservableMedia,
        private router: Router,
        private schoolYearPipe: SchoolYearPipe,
        private splashService: SplashService,
        private titleCasePipe: TitleCasePipe,
        private userService: UserService
    ) {}

    ngOnDestroy() {
        this._subRelease.next();
        this._subRelease.complete();
    }

    ngOnInit() {
        const self = this;

        self.AcceleratedDegreeProgramChoice = null;
        self.AvailableColleges = null;
        self.CanAddTerms = false;
        self.CanBypassAdmin = false;
        self.ContactEmail = null;
        self.ContactPhone = null;
        self.Counselors = null;
        self.DualEnrollmentProgramChoice = null;
        self.FilteredStudentCollegeInfo = [];
        self.ContactPhone = null;
        self.HasSeenEarlyAdmissionsPopup = false;
        self.HasCompletedOrientation = false;
        self.PartialViewReady = false;
        self.RequiresOrientation = false;
        self.SelectedCollege = null;
        self.SelectedCollegeCourses = null;
        self.SelectedCollegeDepartments = null;
        self.SelectedSchoolYear = null;
        self.SelectedStudent = null;
        self.ShowAgreements = false;
        self.ShowTestHistory = false;
        self.StudentCollegeInfo = [];
        self.StudentIDAtCollege = null;
        self.StudentSchedule = null;
        self.StudentScheduleNotes = null;

        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
            ? 'sm'
            : self.mediaChange.isActive('md')
            ? 'md'
            : self.mediaChange.isActive('lg')
            ? 'lg'
            : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';

        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subRelease))
            .subscribe((media) => {
                self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
                self.LastSizeCode = media.mqAlias;
            });

        // We have to wait for the first triggering of the user object info in order to load the component, since many
        // things inside of this need the authtoken to be available.
        self.userService.UserSubject.pipe(
            takeUntil(self._subRelease),
            first<UserInfo>((user) => user != null && !!user.AuthToken)
        ).subscribe(
            (user) => {
                self.User = user;

                // Set up constant monitoring of the user object, to catch AuthToken updates.
                self.userService.UserSubject.pipe(takeUntil(self._subRelease)).subscribe((_user) => {
                    self.User = _user;

                    // If the current role is a counselor role, we check for designee access with CanBypassAdmin rights
                    if (self.User && self.User.CurrentRole === 'Counselor') {
                        self.appService.GetDesigneeCounselorRights(self.User.AuthToken).subscribe(
                            (rights) => {
                                self.DesigneeCounselorRights = rights;

                                self.UpdateDesigneeRights();
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                    } else {
                        // Null out the designee rights.
                        self.DesigneeCounselorRights = null;
                        self.CanBypassAdmin = false;
                    }
                });

                // Now, wait for static system-wide values to be loaded.
                zip(
                    self.appService.GetAllColleges(self.User.AuthToken),
                    self.appService.GetCurrentSchoolYear(),
                    self.appService.GetDualEnrollmentPrograms(self.User.AuthToken),
                    self.appService.GetAcceleratedDegreePrograms(self.User.AuthToken),
                    function (colleges, curYear, dePrograms, accPrograms) {
                        return {
                            Colleges: colleges,
                            CurrentYear: curYear,
                            DEPrograms: dePrograms,
                            AccPrograms: accPrograms,
                        };
                    }
                )
                    .pipe(takeUntil(self._subRelease))
                    .subscribe(
                        (staticpacket) => {
                            // Store these static system-wide values.
                            self.AcceleratedDegreePrograms = staticpacket.AccPrograms;
                            self.AvailableColleges = staticpacket.Colleges;
                            self.CurrentSchoolYear = staticpacket.CurrentYear;
                            self.DualEnrollmentPrograms = staticpacket.DEPrograms;

                            // Default the selected school year to the appservice setting
                            self.SelectedSchoolYear = self.appService.SelectedSchoolYear;

                            // Determine if we should be offering the additional terms buttons at the top. This would only be the
                            // case if there are any colleges with an active window open, and only if the SelectedSchoolYear value
                            // is >= the CurrentSchoolYear. (In other words, you can add a new term/college if the selected school
                            // year is this year right now, or if it is the upcoming school year (in cases where the new year is
                            // rolled into DELTA ahead of time.)
                            self.CanAddTerms =
                                self.AvailableColleges.filter((item) => item.AnyOpenTerms === true).length > 0 &&
                                self.CurrentSchoolYear.localeCompare(self.SelectedSchoolYear) <= 0;

                            // Now, subscribe to any changes to current selection items (selected school year, selected student)
                            combineLatest(self.route.params, self.appService.SelectedSchoolYearSubject, function (params, selYear) {
                                return {
                                    Params: params,
                                    SelectedYear: selYear,
                                };
                            })
                                .pipe(takeUntil(self._subRelease))
                                .subscribe(
                                    (packet) => {
                                        // If we have no user object, or we do but no authtoken (aka logout), bail out.
                                        if (!self.User || !self.User.AuthToken) {
                                            return;
                                        }

                                        self.SelectedSchoolYear = packet.SelectedYear;
                                        self.SetTimelineSteps();

                                        // Update our ability to add terms, in case the user changed the currently selected year.
                                        self.CanAddTerms =
                                            self.AvailableColleges.filter((item) => item.AnyOpenTerms === true).length > 0 &&
                                            self.CurrentSchoolYear.localeCompare(self.SelectedSchoolYear) <= 0;

                                        // Grab parameters from the URL. These could be updated by the controller and may not
                                        // require reloading everything.
                                        const params_RecordID =
                                            packet && packet.Params['RecordID'] != null ? +packet.Params['RecordID'] : null;
                                        // let params_SchoolYear = packet && packet.Params['SchoolYear'];
                                        const params_StudentID = packet && packet.Params['StudentID'];
                                        // let params_CollegeID = (packet && packet.Params['CollegeID'] != null ?
                                        //  +packet.Params['CollegeID'] : null);
                                        // let params_Term = packet && packet.Params['Term'];

                                        // Update all params into the component
                                        self.Params_RecordID = params_RecordID;
                                        // self.Params_SchoolYear = params_SchoolYear;
                                        self.Params_StudentID = params_StudentID;
                                        // self.Params_CollegeID = params_CollegeID;
                                        // self.Params_Term = params_Term;

                                        // There are multiple things to load here:
                                        // 1) Student demographic information. This will only need to be loaded once per student since
                                        // we only show the most recent known info.
                                        // 2) A full load of all college data (such as courses at the college) in case a college
                                        // has changed (or not been loaded yet)
                                        // 3) The list of college DE term requests made by the student
                                        // 4) The list of course choices and notes for a specific college term request chosen.

                                        let studentDemoLoadNeeded = false;

                                        // Loading student demo depends on whether or not we have the info already loaded, or if we
                                        // do have it loaded but somehow the parameters pick out a different student ID than what is loaded.
                                        studentDemoLoadNeeded =
                                            !self.SelectedStudent ||
                                            (self.SelectedStudent &&
                                                params_StudentID &&
                                                params_StudentID !== self.SelectedStudent.StudentID);

                                        // Initiate loading by either querying for the student demo info, or using the already loaded info.
                                        let stuDemoObs: Observable<StudentInfo>;

                                        if (studentDemoLoadNeeded) {
                                            // Load student demographic. If this is the parent, we look to params for a student ID
                                            // so we can pull the student from their list of attached kids.
                                            // Otherwise, we simply pull based upon the parameters (or null if this is the student themself)
                                            if (self.User.IsParent) {
                                                // For parents, grab the list of student children. Once we have that, we either try
                                                // to serve up the student ID requested in the parameters (if one is provided), and
                                                // if not, grab the first student?
                                                stuDemoObs = self.appService.GetStudentsForParent(self.User.AuthToken).pipe(
                                                    map((students) => {
                                                        let foundChild: StudentInfo;

                                                        if (self.Params_StudentID) {
                                                            // Is the student ID in the list?
                                                            if (students && !!students.length) {
                                                                foundChild = students.find((item) => {
                                                                    return item.StudentID === self.Params_StudentID;
                                                                });

                                                                if (!foundChild) {
                                                                    foundChild = students[0];
                                                                }
                                                            }
                                                        } else {
                                                            // Grab the first child found, if any
                                                            foundChild = students && students.length && students[0];
                                                        }

                                                        return foundChild;
                                                    })
                                                );
                                            } else {
                                                // Non-Parent loading.
                                                stuDemoObs = self.appService.GetStudentSchoolInformationByYear(
                                                    self.User.AuthToken,
                                                    // Changed 06/12/2024, due to issue with a senior student applying for summer term
                                                    // before graduation, but is also a newer student with no proior DE requests.
                                                    // In this case, null check is not needed - EE
                                                    self.Params_StudentID,
                                                    // self.User.IsStudent ? null : self.Params_StudentID,
                                                    self.CurrentSchoolYear
                                                );
                                            }
                                        } else {
                                            // Already have loaded demo. Just pass back what we have as a pseudo-call.
                                            stuDemoObs = empty().pipe(startWith(self.SelectedStudent));
                                        }

                                        // Trigger the loading of the student demo (if needed)
                                        stuDemoObs.pipe(takeUntil(self._subRelease)).subscribe(
                                            (studentInfo) => {
                                                if (studentInfo) {
                                                    // Update the component with the imported student info record
                                                    self.SelectedStudent = studentInfo;
                                                    self.appService.SelectedStudent = studentInfo;
                                                    // self.StudentCollegeInfo = null;

                                                    self.ContactEmail = studentInfo.StudentEmail;
                                                    self.ContactPhone = studentInfo.StudentPhone;

                                                    // Now, if we do not have terms requests loaded for this student yet, load them now
                                                    // before we decide what else we need to load.
                                                    const termsObs =
                                                        !self.StudentCollegeInfo ||
                                                        !self.StudentCollegeInfo.length ||
                                                        (params_StudentID && self.StudentCollegeInfo[0].StudentID !== params_StudentID)
                                                            ? self.appService.GetStudentCollegeInformation(
                                                                  self.User.AuthToken,
                                                                  self.SelectedStudent.StudentID
                                                              )
                                                            : empty().pipe(startWith(self.StudentCollegeInfo));

                                                    // Load the counselors for the student's school, if we need to (in case the school
                                                    // number has changed).
                                                    const counsInfo =
                                                        !self.Counselors ||
                                                        !self.Counselors.length ||
                                                        (self.SelectedStudent.SchoolNumber &&
                                                            self.Counselors[0].SchoolNumber !== self.SelectedStudent.SchoolNumber)
                                                            ? self.appService.GetSchoolCounselors(
                                                                  self.User.AuthToken,
                                                                  self.SelectedStudent.SchoolNumber
                                                              )
                                                            : empty().pipe(startWith(self.Counselors));

                                                    // Wait for both to complete
                                                    zip(termsObs, counsInfo, function (terms, counselors) {
                                                        return {
                                                            Terms: terms,
                                                            Counselors: counselors,
                                                        };
                                                    })
                                                        .pipe(takeUntil(self._subRelease))
                                                        .subscribe(
                                                            (_packet) => {
                                                                if (_packet.Counselors) {
                                                                    self.Counselors = _packet.Counselors;
                                                                }

                                                                // Trigger updating of the college terms requests
                                                                self.UpdateAllCollegesInfo(_packet.Terms)
                                                                    .pipe(takeUntil(self._subRelease))
                                                                    .subscribe(
                                                                        (result) => {
                                                                            if (
                                                                                !self.SelectedCollege &&
                                                                                self.FilteredStudentCollegeInfo &&
                                                                                !!self.FilteredStudentCollegeInfo.length
                                                                            ) {
                                                                                self.SelectedCollege =
                                                                                    self.FilteredStudentCollegeInfo[0];

                                                                                if (self.SelectedCollege) {
                                                                                    self.AgreementChecks = <StudentAgreementsStatus>{
                                                                                        PCSBAgreed: !self.User.IsParent
                                                                                            ? self.SelectedCollege
                                                                                                  .StudentPolkAgreementApproved
                                                                                            : self.SelectedCollege.ParentHasApproved,
                                                                                        CollegeAgreed: !self.User.IsParent
                                                                                            ? self.SelectedCollege
                                                                                                  .StudentCollegeAgreementApproved
                                                                                            : self.SelectedCollege.ParentHasApproved,
                                                                                    };
                                                                                    if (self.SelectedCollege.CollegeID) {
                                                                                        self.RequiresOrientation = self.RequiredOrientationColleges.includes(self.SelectedCollege.CollegeID);
                                                                                    }
                                                                                }
                                                                            }

                                                                            // Update the timeline step based upon the form state
                                                                            self.UpdateTimeline();

                                                                            // All is ready. Release splash and view page.
                                                                            self.splashService.CloseSplash();
                                                                            self.PartialViewReady = true;
                                                                        },
                                                                        (error) => {
                                                                            self.errorService.HandleServiceError(error);
                                                                        }
                                                                    );
                                                            },
                                                            (error) => {
                                                                self.errorService.HandleServiceError(error);
                                                            }
                                                        );
                                                }
                                            },
                                            (error) => {
                                                self.errorService.HandleServiceError(error);
                                            }
                                        );
                                    },
                                    (error) => {
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                        },
                        (error) => {
                            self.errorService.HandleServiceError(error);
                        }
                    );
            },
            (error) => {
                self.errorService.HandleServiceError(error);
            }
        );
    }

    // #region Add College Choice Method

    AddCollegeChoice() {
        const self = this;

        // Add a blank entry to the list of colleges
        self.StudentCollegeInfo = self.StudentCollegeInfo || <StudentCollegeInfo[]>[];

        const newEntry: StudentCollegeInfo = <StudentCollegeInfo>{
            SchoolYear: self.SelectedSchoolYear,
            CollegeID: null,
            DualEnrollStudentID: null,
            DualEnrollmentProgramID: null,
            AcceleratedDegreeProgramID: null,
            FormStatus: null,
        };

        self.StudentCollegeInfo.push(newEntry);
        self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

        // Update the selection to this record. We need to parse through and find the record which has a null
        // DualEnrollStudentID value to get the right one.
        self.SelectedCollege = null;

        if (self.FilteredStudentCollegeInfo && self.FilteredStudentCollegeInfo.length) {
            self.SelectedCollege =
                self.FilteredStudentCollegeInfo.find((item) => {
                    return item.DualEnrollStudentID == null;
                }) || null;
            self.UpdateDesigneeRights();
        }
    }

    // #endregion

    // #region Add College Term Method

    AddCollegeTerm() {
        const self = this;

        if (!self.SelectedCollege) {
            return;
        }

        // Create a new entry to the list of colleges, but prefill it with the college that is currently selected,
        // along with the existing dual enrollment program (if available) and school counselor
        const newEntry: StudentCollegeInfo = <StudentCollegeInfo>{
            SchoolYear: self.SelectedSchoolYear,
            CollegeID: self.SelectedCollege.CollegeID,
            DualEnrollStudentID: null,
            DualEnrollmentProgramID: null,
            AcceleratedDegreeProgramID: null,
            CounselorSAPID: self.SelectedCollege.CounselorSAPID,
            FormStatus: null,
        };

        // Add to the list of colleges
        self.StudentCollegeInfo = self.StudentCollegeInfo || [];

        self.StudentCollegeInfo.push(newEntry);
        self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

        // Force a college change handler call to update the available term listing.
        self.CollegeChangeHandler(newEntry).subscribe(
            (success) => {
                // Update the selection to this record. We need to parse through and find the record which has a null
                // DualEnrollStudentID value to get the right one.
                self.SelectedCollege = null;

                if (self.FilteredStudentCollegeInfo && self.FilteredStudentCollegeInfo.length) {
                    for (let fi = 0, fj = self.FilteredStudentCollegeInfo.length; fi < fj; ++fi) {
                        const item = self.FilteredStudentCollegeInfo[fi];

                        if (item.DualEnrollStudentID == null) {
                            const newitem = self.DuplicateStudentCollegeRecord(item);

                            newitem.AvailableTerms = success.AvailableTerms || [];
                            newitem.AnyOpenTerms =
                                newitem.AvailableTerms.findIndex((item1) => {
                                    return item1.CurrentlyAvailable === true;
                                }) >= 0;

                            // Replace the current item in the list.
                            self.FilteredStudentCollegeInfo[fi] = newitem;

                            // Update the selected college binding
                            self.SelectedCollege = newitem;

                            self.UpdateDesigneeRights();

                            break;
                        }
                    }

                    // self.FilteredStudentCollegeInfo.every(item => {
                    //     if (item.DualEnrollmentProgramID == null) {

                    //         // Update the available terms record from what was returned
                    //         item.AvailableTerms = success.AvailableTerms || [];
                    //         item.AnyOpenTerms = (item.AvailableTerms.findIndex(item => {return item.CurrentlyAvailable === true;}) >= 0);

                    //         window.setTimeout(function () {
                    //             self.SelectedCollege = item;

                    //             self.UpdateDesigneeRights();

                    //             console.log('Requests: ', JSON.parse(JSON.stringify(self.SelectedCollege)));
                    //         }, 0);

                    //         return false; // Exit loop
                    //     }
                    //     return true; // Loop again
                    // });
                }
            },
            (errorMsg: string) => {
                self.splashService.SnackbarError(errorMsg);
            }
        );
    }

    // #endregion

    // #region Add Note Method

    AddNote() {
        const self = this;

        // Open the dialog box that collects the note, and wait for it to return or be cancelled.
        self.dialogService
            .OpenCourseNoteDialog({
                TitleText: 'Optional Note',
                MessageText: 'In the box provided below, you may provide an optional note of up to 1000 characters.',
                OKText: 'OK - Submit Note',
                CancelText: 'CANCEL',
            })
            .subscribe((result) => {
                if (result) {
                    // User is submitting a note, which is contained in the returned promise value. Send this note to the database now.
                    this.appService
                        .AddStudentCollegeRecordNote(self.User.AuthToken, self.SelectedCollege.DualEnrollStudentID, result, true)
                        .subscribe(
                            (notes) => {
                                // Update the list of notes we are tracking.
                                self.StudentScheduleNotes = notes;

                                // Toast success.
                                self.splashService.SnackbarSuccess('Note added successfully.');
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Add Student College Record Method

    AddStudentCollegeRecord(col: StudentCollegeInfo) {
        const self = this;

        // Before proceeding, check to see if this is a duplicate entry (in terms of termwindowID, that is) to
        // any other record in the student's file.
        let numTermWindows = 0;
        const twID = col.Term.TermWindowID;
        const prevRecords = [];

        if (self.StudentCollegeInfo && self.StudentCollegeInfo.length) {
            self.StudentCollegeInfo.forEach((item) => {
                if (item.Term && item.Term.TermWindowID === twID) {
                    numTermWindows++;
                    if (item !== col) {
                        prevRecords.push(item);
                    }
                }
            });
        }

        if (numTermWindows >= 1) {
            // This indicates that there is already at least 1 entry with this term window ID. This cannot be added.
            const msg =
                `The college term request you are attempting to add to the DELTA System appears to be a ` +
                `duplicate to an already existing college term request. You may only create <u>one (1)</u> request ` +
                `for a single college term per college year.<br /><br />The following existing request(s) are in ` +
                `the system:<br /><br /><ul>${prevRecords.reduce((prev: string, item: StudentCollegeInfo) => {
                    return (
                        '<li><strong>Request #' +
                        item.DualEnrollStudentID +
                        ': </strong>' +
                        item.CollegeName +
                        ' - ' +
                        self.collegeTermPipe.transform(item.Term.TermCode) +
                        ' ' +
                        self.extendedCollegeTermPipe.transform(item.Term, item.CollegeID) +
                        '<br />(Last Updated On ' +
                        self.datePipe.transform(item.DateUpdated, 'M/d/yyyy h:mm a') +
                        ')</li>'
                    );
                }, '')}</ul><br /><br />Please cancel this duplicate entry using the "Cancel" button and use the previous ` +
                `request listed above for this term's college course requests.`;

            self.dialogService
                .OpenMessageBoxDialog({
                    TitleText: 'Alert - Duplicate Term Request Detected',
                    MessageText: msg,
                    OKText: 'OK',
                    width: '700px',
                    height: '500px',
                })
                .subscribe((result) => {});
            return;
        }

        // Save the provided dual enrollment program ID and/or acceleration program ID, in case they exist at this point.
        // If they do, this is a new term entry and that information is pre-provided, but will be wiped

        // Toss up a splash on the screen.
        self.splashService
            .DisplaySplash({ TitleText: 'Please wait', MessageText: 'Creating college record...' })
            .subscribe((opened) => {
                // Pull together the current college record and call the system to add this record, which also generates a refresh
                // of the entire record for this student in the system.
                self.appService
                    .AddStudentCollegeRecord(
                        self.User.AuthToken,
                        self.User.StudentID,
                        self.User.UserID,
                        self.SelectedSchoolYear,
                        col.Term.TermWindowID,
                        col.CollegeID,
                        col.CounselorSAPID,
                        1
                    )
                    .subscribe(
                        (info: AddStudentCollegeRecordReturn) => {
                            // Update the master list to reflect this provided update list.
                            self.UpdateAllCollegesInfo(info.Requests).subscribe(
                                (success) => {
                                    // Update the selected college. We should be able to use the newly added DualEnrollStudentID
                                    // for this. If one was not provided back, we fallback to a previous default method (If we now
                                    // only have a single record available, it's easy: it's the first entry. Otherwise, we need to
                                    // use the one which matches what we just created instead.)
                                    if (
                                        info.AddedDualEnrollStudentID != null &&
                                        self.FilteredStudentCollegeInfo &&
                                        !!self.FilteredStudentCollegeInfo.length
                                    ) {
                                        self.SelectedCollege = self.FilteredStudentCollegeInfo.find(
                                            (item) => item.DualEnrollStudentID === info.AddedDualEnrollStudentID
                                        );
                                    }

                                    if (
                                        !self.SelectedCollege &&
                                        self.FilteredStudentCollegeInfo &&
                                        self.FilteredStudentCollegeInfo.length === 1
                                    ) {
                                        self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                    }

                                    if (
                                        !self.SelectedCollege &&
                                        self.FilteredStudentCollegeInfo &&
                                        !!self.FilteredStudentCollegeInfo.length
                                    ) {
                                        for (let i = 0, j = self.FilteredStudentCollegeInfo.length; i < j; ++i) {
                                            if (
                                                self.FilteredStudentCollegeInfo[i].CollegeID === col.CollegeID &&
                                                self.FilteredStudentCollegeInfo[i].Term.TermCode === col.Term.TermCode
                                            ) {
                                                self.SelectedCollege = self.FilteredStudentCollegeInfo[i];
                                                break;
                                            }
                                        }
                                    }

                                    if (self.SelectedCollege) {
                                        // Transition to that view
                                        self.SelectCollegeRecord(self.SelectedCollege);
                                    }

                                    self.UpdateTimeline();

                                    self.splashService.CloseSplash();
                                    self.splashService.SnackbarSuccess('Record added successfully.');
                                },
                                (errorMsg: string) => {
                                    self.splashService.CloseSplash();
                                    self.splashService.SnackbarError(errorMsg);
                                }
                            );
                        },
                        (errorMsg: string) => {
                            self.splashService.CloseSplash();
                            self.splashService.SnackbarError(errorMsg);
                        }
                    );
            });
    }

    // #endregion

    // #region Advisor Approve All Courses Method

    AdvisorApproveAllCourses(status: boolean) {
        const self = this;

        if (status !== true) {
            return;
        }

        const toBeScheduled = self.StudentSchedule.slice().filter((item) => {
            return !item.RemovedBy;
        });

        // Open up the special scheduling dialog
        self.dialogService
            .OpenScheduleAllCoursesDialog({
                TitleText: 'Scheduling Info Requested',
                MessageText:
                    `You are about to schedule all classes listed below. Please provide the course reference number ` +
                    `for each course before continuing onward:`,
                OKText: 'Approve & Mark Scheduled',
                CancelText: 'Cancel',
                Courses: toBeScheduled,
            })
            .subscribe((scheduleresult) => {
                if (scheduleresult != null) {
                    // Get a confirmation before taking this step.
                    let totalCredits = 0;

                    let message =
                        `You are about to approve all course requests &amp; mark this student's Dual ` +
                        `Enrollment course list as scheduled:<br /><br />
                    <strong>Student: </strong>${self.titleCasePipe.transform(
                        self.SelectedStudent.LastName
                    )}, ${self.titleCasePipe.transform(self.SelectedStudent.FirstName)}<br />
                    <strong>Student ID: </strong>${self.SelectedStudent.StudentID}<br />
                    <strong>Grade: </strong>${self.SelectedStudent.GradeLevel}<br />
                    <strong>College: </strong>${self.SelectedCollege.CollegeName}<br />
                    <strong>Year: </strong>${self.schoolYearPipe.transform(self.SelectedCollege.SchoolYear)}<br />
                    <strong>Term: </strong>${self.collegeTermPipe.transform(self.SelectedCollege.Term.TermCode)}<br />
                    <strong>Courses: </strong><br />`;

                    scheduleresult.forEach((item) => {
                        if (item.DateRemoved == null) {
                            message += `${item.FullCode} - ${item.Name} (${self.decimalPipe.transform(
                                item.Credits,
                                '1.1-1'
                            )} credits)<br />`;
                            totalCredits += item.Credits;
                        }
                    });

                    message +=
                        `<span style="border-top:1px solid black"><strong>Total Credit Hours: </strong>${self.decimalPipe.transform(
                            totalCredits,
                            '1.1-1'
                        )}</span><br />
                    <br />Are you sure you wish to approve &amp; mark this set of course requests as scheduled at ` +
                        `this time? This action will prevent any changes from being made to this set of course requests ` +
                        `by the student or his school. Do you wish to continue?`;

                    self.RequestAllApproval(message, scheduleresult);
                }
            });
    }

    // #endregion

    // #region Approve All Courses Method

    ApproveAllCourses(status: ApproveRequestInfo) {
        const self = this;

        if (!status || status.ActionNeeded !== true) {
            return;
        }

        // If this is an advisor or college admin, use a different method since advisors must scheduled all courses at this time.
        if (self.User.IsAdvisor || self.User.IsCollegeAdmin) {
            self.AdvisorApproveAllCourses(status.ActionNeeded);
            return;
        }

        // Get a confirmation before taking this step.
        let totalCredits = 0;

        let message = `You are about to approve &amp; submit the following Dual Enrollment course request(s):<br /><br />
        <strong>Student: </strong>${self.SelectedStudent.LastName}, ${self.SelectedStudent.FirstName}<br />
        <strong>Student ID: </strong>${self.SelectedStudent.StudentID}<br />
        <strong>Grade: </strong>${self.SelectedStudent.GradeLevel}<br />
        <strong>College: </strong>${self.SelectedCollege.CollegeName}<br />
        <strong>Year: </strong>${self.schoolYearPipe.transform(self.SelectedCollege.SchoolYear)}<br />
        <strong>Term: </strong>${self.collegeTermPipe.transform(self.SelectedCollege.Term.TermCode)}<br />
        <strong>Courses: </strong><br />`;

        self.StudentSchedule.forEach((item) => {
            if (item.DateRemoved == null) {
                message += `${item.FullCode} - ${item.Name} (${self.decimalPipe.transform(item.Credits, '1.1-1')} credits)<br />`;
                totalCredits += item.Credits;
            }
        });

        message +=
            `<span style="border-top:1px solid black"><strong>Total Credit Hours: </strong>${self.decimalPipe.transform(
                totalCredits,
                '1.1-1'
            )}</span><br /><br />
        Are you sure you wish to approve &amp; submit this set of course requests at this time? Although you ` +
            `can make changes to this list after you have approved the list, once approved this set of course requests will be visible`;

        if (self.User && self.User.IsCounselor && status.BypassAdmin === true) {
            message += ` to the <strong>college advisor</strong> assisting this student and scheduling of courses may take place.`;
        } else if (self.User && self.User.IsCounselor && status.BypassAdmin !== true) {
            message += ` to your school administration and can be approved by an administrator and sent to the college for scheduling.`;
        } else if (self.User && (self.User.IsSchoolAdmin || self.User.IsDistrictAdmin || self.User.IsDeveloper)) {
            message += ` to the college advisor assisting this student and scheduling of courses may take place.`;
        } else {
            message += '.';
        }

        message += ` Do you wish to continue?`;

        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'YES - Approve & Submit',
                CancelText: 'NO - Cancel',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User selected to proceed. Pass confirmation off to the service.
                    let svcObs: Observable<StudentCollegeInfo[]>;

                    if (self.User && self.User.IsCounselor) {
                        svcObs = self.appService.SchoolCounselorUpdateStudentCollegeRecord(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.User.SAPID,
                            self.SelectedCollege.FormStatus,
                            status.BypassAdmin
                        );
                    } else if (self.User && (self.User.IsSchoolAdmin || self.User.IsDistrictAdmin || self.User.IsDeveloper)) {
                        svcObs = self.appService.SchoolAdminUpdateStudentCollegeRecord(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.User.SAPID,
                            self.SelectedCollege.FormStatus
                        );
                    }

                    svcObs &&
                        svcObs.subscribe(
                            (infoList) => {
                                // Update the info in the system.
                                self.UpdateAllCollegesInfo(infoList).subscribe(
                                    (success) => {
                                        self.UpdateTimeline();

                                        // Toast the successful approval
                                        self.splashService.CloseSplash();
                                        self.splashService.SnackbarSuccess(
                                            'Dual Enrollment Record Approved & Submitted Successfully.'
                                        );
                                    },
                                    (error) => {
                                        self.splashService.CloseSplash();
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                            },
                            (error) => {
                                this.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Approve Course Choice Method

    ApproveCourseChoice(course: CourseChoice, isUpdate?: boolean) {
        const self = this;

        if (!course) {
            return;
        }

        // Check to see if we have a college student ID entered. If we do not, they must set that before they can
        // approve a course, remove a course, or approve a schedule.
        if (!self.SelectedCollege.StudentCollegeID) {
            self.dialogService
                .OpenMessageBoxDialog({
                    TitleText: 'Alert',
                    IconName: 'error',
                    MessageText:
                        `This student does not have an updated College Student ID number. Please use the ` +
                        `provided "Update" button to enter the student's College Student ID number for ` +
                        `${self.SelectedCollege.CollegeName} before proceeding.`,
                    OKText: 'OK',
                })
                .subscribe((res) => {});

            return;
        }

        // Get the course reference number from a dialog (or a check stating it is taught at the county schools).
        const message =
            `Please ${
                course.ReferenceNumber ? 'verify' : 'provide'
            } the Course Reference Number for the course/section that this student is ` +
            `scheduled into in the box provided below. If this course is being taught at a Polk County School District ` +
            `school, please check the provided checkbox and do not provide a reference number.<br /><br />
        <strong>Prefix: </strong>${course.Prefix}<br />
        <strong>Code: </strong>${course.Code}<br />
        <strong>Name: </strong>${course.Name}`;

        self.dialogService
            .OpenScheduleCourseDialog({
                TitleText: 'Schedule Course',
                MessageText: message,
                OKText: 'Done',
                CancelText: 'CANCEL',
                ReferenceNumber: course.ReferenceNumber,
                CountyTaught: course.CountyTaught,
            })
            .subscribe((result) => {
                if (result != null) {
                    // User has opted to proceed. Using the provided values, schedule this course for the student.
                    self.splashService
                        .DisplaySplash({
                            TitleText: 'Please wait',
                            MessageText: isUpdate ? 'Updating course reference number...' : 'Uploading course approval',
                        })
                        .pipe(takeUntil(self._subRelease))
                        .subscribe(() => {
                            self.appService
                                .ScheduleStudentCollegeRecordCourse(
                                    self.User.AuthToken,
                                    course.DualEnrollStudentID,
                                    course.CourseChoiceID,
                                    self.User.UserID,
                                    result.ReferenceNumber,
                                    result.CountyTaught
                                )
                                .subscribe(
                                    (info) => {
                                        const courses = info && info.Requests;

                                        // Update the request list by resetting the variable
                                        self.UpdateRequestsInfo(courses, false);

                                        // If this is not a student, update the notes list by resetting the scope variable
                                        // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                                        if (self.User.CurrentRole !== 'Parent') {
                                            self.StudentScheduleNotes = info.Notes;
                                        }

                                        // Update the timeline loaded
                                        self.UpdateTimeline();

                                        // Drop the splash.
                                        self.splashService.CloseSplash();

                                        // Toast success.
                                        self.splashService.SnackbarSuccess(
                                            isUpdate
                                                ? 'Course reference number updated successfully.'
                                                : 'Course scheduled successfully.'
                                        );

                                        // If there are no remaining courses left to be scheduled which are still active, and the
                                        // current form status of this request is not 10 (ie, college approved) for convenience
                                        // ask the advisor if they wish to go ahead and certify the course record as approved.
                                        // This is done so that a college advisor can update a course reference number without
                                        // having to click through this again.
                                        const unscheduled = self.StudentSchedule.find((item) => {
                                            return item.DateRemoved == null && item.DateScheduled == null;
                                        });

                                        if (self.StudentSchedule && unscheduled == null && self.SelectedCollege.FormStatus !== 10) {
                                            // Pop up asking if the advisor wishes to mark the schedule as approved.
                                            let totalCredits = 0;
                                            let confmsg =
                                                `All course requests which are still active for this student's current ` +
                                                `dual enrollment record for ${self.SelectedCollege.CollegeName} have been ` +
                                                `approved and/or had course reference numbers added. Would you ` +
                                                `like to mark this student's schedule as approved?<br /><br />
                                    <strong>College: </strong>${self.SelectedCollege.CollegeName}<br />
                                    <strong>Year: </strong>${self.schoolYearPipe.transform(self.SelectedCollege.SchoolYear)}<br />
                                    <strong>Term: </strong>${self.collegeTermPipe.transform(self.SelectedCollege.Term.TermCode)}<br />
                                    <strong>Courses: </strong><br />`;

                                            self.StudentSchedule.forEach((item) => {
                                                if (item.DateRemoved == null) {
                                                    confmsg += `${item.FullCode} - ${item.Name} (${self.decimalPipe.transform(
                                                        item.Credits,
                                                        '1.1-1'
                                                    )} credits)<br />`;
                                                    totalCredits += item.Credits;
                                                }
                                            });

                                            confmsg +=
                                                `<span style="border-top:1px solid black"><strong>Total Credit ` +
                                                `Hours: ${self.decimalPipe.transform(totalCredits, '1.1-1')}</span><br /><br />
                                    Are you sure you wish to approve &amp; mark this set of course requests as scheduled ` +
                                                `at this time? This action will prevent any changes from being made to ` +
                                                `this set of course requests by the student or his school. Do you wish to continue?`;

                                            self.RequestAllApproval(confmsg, null);
                                        }
                                    },
                                    (error) => {
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                        });
                }
            });
    }

    // #endregion

    // #region Cancel College Choice Method

    CancelCollegeChoice(col: StudentCollegeInfo) {
        const self = this;

        if (!col) {
            return;
        }

        // User agrees to cancel entry. Remove it from the screen.
        const toGoIndex = self.StudentCollegeInfo.indexOf(col);
        const oldEntry = self.StudentCollegeInfo.splice(toGoIndex, 1);

        self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

        // Reselect the topmost entry.
        if (self.FilteredStudentCollegeInfo && self.FilteredStudentCollegeInfo.length) {
            self.SelectCollegeRecord(self.FilteredStudentCollegeInfo[0]);
        }
    }

    // #endregion

    // #region College Change Method

    CollegeChange(col: StudentCollegeInfo) {
        const self = this;

        self.CollegeChangeHandler(col).subscribe();
    }

    // #endregion

    // #region College Change Handler Method

    CollegeChangeHandler(col: StudentCollegeInfo) {
        const self = this;

        // A college selection has changed (perhaps). Fire a request to the system to retrieve the available
        // terms for this college and the selected school year.
        if (col && col.CollegeID) {
            self.RequiresOrientation = self.RequiredOrientationColleges.includes(col.CollegeID)
            return self.appService.GetAvailableTerms(self.User.AuthToken, col.CollegeID, null).pipe(
                takeUntil(self._subRelease),
                map((termslist) => {
                    // Store in this college object
                    col.AvailableTerms = termslist;
                    col.AvailableTerms = col.AvailableTerms || [];
                    col.AnyOpenTerms =
                        col.AvailableTerms.findIndex((item) => {
                            return item.CurrentlyAvailable === true;
                        }) >= 0;

                    // If there's no established DualEnrollStudentID value, this is a new college being designed, so wipe
                    // out the previously selected term, since this is a new college and it's not accurate.
                    if (col.DualEnrollStudentID == null) {
                        col.Term = null;
                    }

                    return col;
                })
            );
        }

        return empty().pipe(startWith(null));
    }

    // #endregion

    // #region Download PDF Method

    DownloadPDF() {
        const self = this;

        self.downloadService
            .RetrieveDownload(
                HttpMethod.GET,
                `Api/Services/PDF/PDFDownloadStudentCollegeRecord`,
                {
                    AuthToken: self.User.AuthToken,
                    DualEnrollStudentID: self.SelectedCollege.DualEnrollStudentID,
                    Attachment: true,
                },
                DownloadFormat.PDF
            )
            .pipe(takeUntil(self._subRelease))
            .subscribe(
                (success) => {
                    // Drop the splash?
                },
                (error) => {
                    self.errorService.HandleServiceError(error);
                }
            );
    }

    // #endregion

    // #region Download Ref PDF

    DownloadRefPDF() {
        // this.downloadService
        //     .RetrieveFile(
        //         HttpMethod.GET,
        //         `assets/DE_directions_for_finding_reference_numbers_ellucian_v1.pdf`,
        //         DownloadFormat.PDF,
        //         'DE_directions_for_finding_reference_numbers_ellucian_v1.pdf'
        //     )
        //     .pipe(takeUntil(this._subRelease))
        //     .subscribe(
        //         (success) => {},
        //         (error) => {
        //             this.errorService.HandleServiceError(error);
        //         }
        //     );
        const self = this;
        
        switch (self.SelectedCollege.CollegeID) {
            // Polk State College
            case 2:
                window.open(`assets/DE_directions_for_finding_reference_numbers_ellucian_v1.pdf`, '_blank');
                break;
            // Southeastern University College
            case 4:
                window.open(`assets/DELTA_AND_JICS_INSTRUCTIONS.pdf`, '_blank');                
                break;
        
            default:
                break;
        }
    }

    // #endregion

    // #region Duplicate Student College Record Method

    DuplicateStudentCollegeRecord(rec: StudentCollegeInfo) {
        if (!rec) {
            return rec;
        }

        const newitem = <StudentCollegeInfo>JSON.parse(JSON.stringify(rec));

        newitem.AvailableTerms = newitem.AvailableTerms || [];
        newitem.AnyOpenTerms =
            newitem.AvailableTerms.findIndex((item) => {
                return item.CurrentlyAvailable === true;
            }) >= 0;

        // Process all date objects into dates
        newitem.AgreementTextDate = newitem.AgreementTextDate ? new Date(newitem.AgreementTextDate) : null;
        newitem.CollegeApprovedDate = newitem.CollegeApprovedDate ? new Date(newitem.CollegeApprovedDate) : null;
        newitem.CounselorApprovedDate = newitem.CounselorApprovedDate ? new Date(newitem.CounselorApprovedDate) : null;
        newitem.DateUpdated = newitem.DateUpdated ? new Date(newitem.DateUpdated) : null;
        newitem.ParentApprovedDate = newitem.ParentApprovedDate ? new Date(newitem.ParentApprovedDate) : null;
        newitem.SchoolApprovedDate = newitem.SchoolApprovedDate ? new Date(newitem.SchoolApprovedDate) : null;

        if (newitem.Term) {
            newitem.Term.DateBegin = newitem.Term.DateBegin ? new Date(newitem.Term.DateBegin) : null;
            newitem.Term.DateEnd = newitem.Term.DateEnd ? new Date(newitem.Term.DateEnd) : null;
        }

        if (newitem.AvailableTerms && newitem.AvailableTerms.length) {
            newitem.AvailableTerms.forEach((data) => {
                data.DateBegin = data.DateBegin ? new Date(data.DateBegin) : null;
                data.DateEnd = data.DateEnd ? new Date(data.DateEnd) : null;
            });
        }

        return newitem;
    }

    // #endregion

    // #region Eligibility Handler Method

    EligibilityHandler(courses: number[] | null) {
        const self = this;

        // Convert the list of numbers into a single bitfield value before sending.
        const cval = courses != null ? courses.reduce((p, c) => p + c, 0) : null;

        // Send this value to the database for updating.
        self.appService.UpdateStudentEligibility(self.User.AuthToken, self.SelectedCollege.DualEnrollStudentID, cval).subscribe(
            (success) => {
                // Toast success.
                self.splashService.SnackbarSuccess('Student eligibility by course grade status updated successfully.');

                // Update the currently selected college by setting the eligibility to the proper value.
                self.SelectedCollege.EligibilityByCourseGrade = success
                    ? success.EligibilityByCourseGrade
                    : self.SelectedCollege.EligibilityByCourseGrade;
            },
            (error) => {
                self.errorService.HandleServiceError(error);
            }
        );
    }

    // #endregion

    // #region Fast Track Handler Method

    FastTrackHandler(status: boolean) {
        const self = this;

        // Send this value to the database for updating.
        self.appService.UpdateStudentFastTrack(self.User.AuthToken, self.SelectedCollege.DualEnrollStudentID, status).subscribe(
            (success) => {
                // Toast success.
                self.splashService.SnackbarSuccess('FastTrack advising status updated successfully.');

                // Update the currently selected college by setting the fast track to the proper value.
                self.SelectedCollege.FastTrackAdvised = success ? success.FastTrackAdvised : self.SelectedCollege.FastTrackAdvised;
            },
            (error) => {
                self.errorService.HandleServiceError(error);
            }
        );
    }

    // #endregion

    // #region Is Next School Year Method

    IsNextSchoolYear(curYear: string, nextYear: string) {
        const self = this;

        if (!curYear || !nextYear) {
            return false;
        }

        const yearval = +curYear.substr(2, 2);
        const folYear = ('00' + yearval).slice(-2) + ('00' + (yearval + 1)).slice(-2);

        return nextYear === folYear;
    }

    // #endregion

    // #region Is Past School Year Method

    IsPastSchoolYear(curYear: string, pastYear: string) {
        const self = this;

        if (!curYear || !pastYear) {
            return false;
        }

        const yearval = +curYear.substr(0, 2);
        const prevYear = ('00' + (yearval - 1)).slice(-2) + ('00' + yearval).slice(-2);

        return pastYear === prevYear;
    }

    // #endregion

    // #region Parent Submit Approval Method

    ParentSubmitApproval() {
        const self = this;

        // Get approval for this process
        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: `You are about to transmit your acceptance of the terms and conditions for ${
                    self.SelectedCollege.CollegeName
                } for the ${self.collegeTermPipe.transform(self.SelectedCollege.Term.TermCode).toProperCase()} Term for the ${
                    self.SelectedCollege.SchoolYear
                } school year. Are you sure?`,
                OKText: 'Yes',
                CancelText: 'No - Cancel',
            })
            .subscribe((yes) => {
                if (yes === true) {
                    // Signal approval to the system for the college currently selected, along with the county one as well by default.
                    self.appService
                        .ParentApproveCollegeAgreement(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.User.UserID,
                            self.User.FocusStaffID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.SelectedCollege.CollegeID,
                            self.SelectedCollege.SchoolYear,
                            self.SelectedCollege.Term.TermWindowID,
                            false,
                            null,
                            null,
                            null
                        )
                        .subscribe(
                            (terms) => {
                                // Both the county and the college terms were set as approved. Now, to be safe, we will
                                // requery for the current terms for the student and this will update the flag in the selected
                                // college entry to show it was accepted, which will drive the UI to update.
                                self.appService
                                    .GetStudentCollegeInformation(self.User.AuthToken, self.SelectedStudent.StudentID)
                                    .subscribe(
                                        (infoList) => {
                                            // Update the master list to reflect this provided update list.
                                            const curCollege = self.SelectedCollege.DualEnrollStudentID;
                                            self.SelectedCollege = null;

                                            self.UpdateAllCollegesInfo(infoList).subscribe(
                                                (success) => {
                                                    // Update the selected college if we now only have a single record available.
                                                    if (self.FilteredStudentCollegeInfo && self.FilteredStudentCollegeInfo.length) {
                                                        self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                                    } else {
                                                        // Try to reset the existing one before this call updated.
                                                        self.SelectedCollege = self.FilteredStudentCollegeInfo.find((item) => {
                                                            return item.DualEnrollStudentID === curCollege;
                                                        });

                                                        if (
                                                            !self.SelectedCollege &&
                                                            self.FilteredStudentCollegeInfo &&
                                                            self.FilteredStudentCollegeInfo.length
                                                        ) {
                                                            self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                                        }
                                                    }

                                                    self.UpdateDesigneeRights();

                                                    self.splashService.CloseSplash();
                                                    self.splashService.SnackbarSuccess(
                                                        'Acceptance of terms transmitted successfully.'
                                                    );
                                                },
                                                (errorMsg: string) => {
                                                    self.splashService.CloseSplash();
                                                    self.splashService.SnackbarError(errorMsg);
                                                }
                                            );
                                        },
                                        (errorMsg: string) => {
                                            self.splashService.CloseSplash();
                                            self.splashService.SnackbarError(errorMsg);
                                        }
                                    );
                            },
                            (errorMsg: string) => {
                                self.splashService.SnackbarError(errorMsg);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Program Option Change

    ProgramOptionChange(event: MatSelectChange) {
        const self = this;

        if (event.value === 2 && !self.HasSeenEarlyAdmissionsPopup) {
            // User has selected Early Admissions. Warn via a dialog.
            self.dialogService
                .OpenMessageBoxDialog({
                    TitleText: 'Early Admission Program Notice',
                    MessageText:
                        `By accepting this student for Early Admission, you are confirming this student has met the ` +
                        `following requirements to participate in Early Admission:<br /><ul><li>The student is a senior.</li>` +
                        `<li>The student has a minimum 3.2 unweighted GPA.</li><li>The student has 21 High School credits ` +
                        `by the beginning of the upcoming semester.</li><li>The student has met all of the ` +
                        `requirements of PERT.</li><li>The student has met any other requirements in the Articulation ` +
                        `Agreement.</li></ul>`,
                    OKText: 'OK',
                    height: '430px',
                    width: '600px',
                })
                .subscribe((_) => {
                    self.HasSeenEarlyAdmissionsPopup = true;
                });
        }
    }

    // #endregion

    // #region Proxy Approve Method

    ProxyApprove() {
        const self = this;

        if (!self.SelectedCollege) {
            return;
        }

        // In order to proxy approve, we must gather some information; namely, the parent's name in attendance, and
        // the relationship of the parent/guardian/person to the student. We'll use a master observable to handle when
        // the process concludes, and then call different confirmation dialogs as needed.
        const serviceObs: Observable<any> = null;
        let proxyparentname = null;
        let proxyrelationship = null;
        let proxydescription = null;

        const message =
            `You are about to approve the Terms & Conditions on behalf of a parent. Before proceeding, you ` +
            `must discuss the terms and conditions for both the Polk County Public Schools system, as well as the terms ` +
            `and conditions for ${self.SelectedCollege.CollegeName}. Please check the box provided below and provide ` +
            `the requested information in order to continue.`;

        self.dialogService
            .OpenProxyApproveDialog({
                TitleText: 'Information Requested',
                MessageText: message,
                OKText: 'Approve on Behalf of Parent',
                CancelText: 'CANCEL',
                Statement:
                    `I have reviewed the Terms and Conditions of both the district and the college with the ` +
                    `parent/guardian prior to submitting this approval on their behalf.`,
                StudentName: self.SelectedStudent
                    ? self.SelectedStudent.FirstName + ' ' + self.SelectedStudent.LastName
                    : 'the student',
            })
            .subscribe((result) => {
                if (result != null) {
                    // User agreed. Package up the values and send to the WebAPI controller.
                    proxyparentname = result.ProxyParentName;
                    proxyrelationship = result.ProxyRelationship;
                    proxydescription = result.ProxyDescription;

                    // Send request off to the service layer to approve both the county and the school terms.
                    self.appService
                        .ParentApproveCollegeAgreement(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.User.UserID,
                            self.User.FocusStaffID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.SelectedCollege.CollegeID,
                            self.SelectedCollege.SchoolYear,
                            self.SelectedCollege.Term.TermWindowID,
                            true,
                            proxyparentname,
                            proxyrelationship,
                            proxydescription
                        )
                        .subscribe(
                            (terms) => {
                                // Both the county and the college terms were set as approved via proxy. Now, to be safe, we
                                // will requery for the current terms for the student and this will update the flag in the selected
                                // college entry to show it was accepted, which will drive the UI to update.
                                this.appService
                                    .GetStudentCollegeInformation(self.User.AuthToken, self.SelectedStudent.StudentID)
                                    .subscribe(
                                        (infoList) => {
                                            // Update the master list to reflect this provided update list.
                                            const curCollege = self.SelectedCollege.DualEnrollStudentID;
                                            self.SelectedCollege = null;

                                            self.UpdateAllCollegesInfo(infoList)
                                                .pipe(takeUntil(self._subRelease))
                                                .subscribe(
                                                    (success) => {
                                                        // Update the selected college if we now only have a single record available.
                                                        if (self.FilteredStudentCollegeInfo) {
                                                            if (self.FilteredStudentCollegeInfo.length === 1) {
                                                                self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                                            } else {
                                                                // Try to reset the existing one before this call updated.
                                                                const entry = self.FilteredStudentCollegeInfo.find((item) => {
                                                                    return item.DualEnrollStudentID === curCollege;
                                                                });
                                                                this.SelectedCollege = entry;

                                                                if (!self.SelectedCollege) {
                                                                    self.SelectedCollege = this.FilteredStudentCollegeInfo[0];
                                                                }
                                                            }
                                                        }

                                                        self.UpdateDesigneeRights();

                                                        self.UpdateTimeline();

                                                        self.splashService.SnackbarSuccess(
                                                            'Proxy acceptance of terms transmitted successfully.'
                                                        );
                                                    },
                                                    (error) => {
                                                        self.errorService.HandleServiceError(error);
                                                    }
                                                );
                                        },
                                        (error) => {
                                            self.errorService.HandleServiceError(error);
                                        }
                                    );
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Remove College Choice Method

    RemoveCollegeChoice(col: StudentCollegeInfo) {
        const self = this;

        const college = self.AvailableColleges.filter((item) => {
            return item.CollegeID === col.CollegeID;
        });
        const collegeName = college && college.length ? college[0].CollegeName : '';

        // If this entry is completely blank, no need to get confirmation. Just remove it.
        if (!col.DualEnrollStudentID && !col.CollegeID && !col.Term && !col.CounselorSAPID) {
            const toGoIndex = self.StudentCollegeInfo.indexOf(col);
            const oldEntry = self.StudentCollegeInfo.splice(toGoIndex, 1);
            self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

            self.splashService.SnackbarSuccess('Record removed successfully.');
            return;
        }

        // Get a confirmation to remove this choice
        const message =
            self.User && self.User.IsStudent
                ? `You are about to remove the following college from your list of requested Dual Enrollment ` +
                  `Colleges for ${self.schoolYearPipe.transform(self.SelectedSchoolYear)}:<br /><br />
        <strong>${collegeName}</strong><br />
        <strong>${self.collegeTermPipe.transform(col.Term.TermCode)} (${self.extendedCollegeTermPipe.transform(
                      col.Term,
                      col.CollegeID
                  )})</strong><br /><br />
        This action will also remove all course requests that have been made so far with this record. Once ` +
                  `removed, you cannot recover this term and must begin the process at this college from the beginning. ` +
                  `Are you sure you wish to continue?`
                : `You are about to remove the following college from the student's list of requested Dual ` +
                  `Enrollment Colleges for ${self.schoolYearPipe.transform(self.SelectedSchoolYear)}:<br /><br />
        <strong>${collegeName}</strong><br />
        <strong>${self.collegeTermPipe.transform(col.Term.TermCode)} (${self.extendedCollegeTermPipe.transform(
                      col.Term,
                      col.CollegeID
                  )})</strong><br /><br />This action will also remove all course requests that have been made ` +
                  `so far with this record. Once removed, you <strong>cannot</strong> recover this term and the student ` +
                  `must begin the process at this college from the beginning. Are you sure you wish to continue?`;

        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'Yes - Remove',
                CancelText: 'No - Cancel',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User agrees to remove entry. Remove it from the screen.
                    const toGoIndex = self.StudentCollegeInfo.indexOf(col);
                    const oldEntry = self.StudentCollegeInfo.splice(toGoIndex, 1);

                    // Check to see if this record has an established dual enrollment record ID value. If not, this is
                    // not yet saved and therefore will not need to go to the database for removal.
                    if (!col.DualEnrollStudentID) {
                        // No need to continue. Just toast it and move on.
                        self.splashService.SnackbarSuccess('Record removed successfully.');
                        return;
                    }

                    // Now make a service call to remove it completely from the system as well.
                    self.appService
                        .RemoveStudentCollegeRecord(
                            self.User.AuthToken,
                            self.User && self.User.IsStudent ? self.User.StudentID : col.StudentID,
                            col.DualEnrollStudentID
                        )
                        .subscribe(
                            (infoList) => {
                                // Reset the information on the screen
                                self.UpdateAllCollegesInfo(infoList).subscribe(
                                    (success) => {
                                        self.UpdateTimeline();

                                        self.splashService.CloseSplash();
                                        self.splashService.SnackbarSuccess('Record removed successfully.');
                                    },
                                    (error) => {
                                        self.splashService.CloseSplash();
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                            },
                            (errorMsg: string) => {
                                self.splashService.CloseSplash();
                                self.splashService.SnackbarError(errorMsg);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Remove Course Choice Method

    RemoveCourseChoice(course: CourseChoice) {
        const self = this;

        // If this is an advisor, check for a college student ID first. If we do not, they must set that before they can
        // approve a course, remove a course, or approve a schedule.
        if (self.User && (self.User.IsAdvisor || self.User.IsCollegeAdmin) && !self.SelectedCollege.StudentCollegeID) {
            self.dialogService
                .OpenMessageBoxDialog({
                    TitleText: 'Alert',
                    IconName: 'error',
                    MessageText:
                        `This student does not have an updated College Student ID number. Please use the ` +
                        `provided "Update" button to enter the student's College Student ID number for ` +
                        `${self.SelectedCollege.CollegeName} before proceeding.`,
                })
                .subscribe(() => {});

            return;
        }

        // Get a confirmation before proceeding to set it as removed.
        let message = `You have chosen to remove the following course from ${
            self.User && self.User.IsStudent ? 'your' : 'the'
        } request list for ${self.SelectedCollege.CollegeName} (${self.collegeTermPipe.transform(
            self.SelectedCollege.Term.TermCode
        )} ${self.schoolYearPipe.transform(self.SelectedSchoolYear)})<br /><br />
        <strong>Prefix: </strong>${course.Prefix}<br />
        <strong>Code: </strong>${course.Code}<br />
        <strong>Name: </strong>${course.Name}`;

        if (self.User && (self.User.IsAdvisor || self.User.IsCollegeAdmin || self.User.IsCollegeSupport)) {
            message += `<br />
            <strong>Reference Number: </strong>${
                (course.ReferenceNumber || '') +
                (course.ReferenceNumber
                    ? '<br /><div style="color:red;font-size:9pt"><em>This course has previously been marked as scheduled.</em></div>'
                    : '')
            }`;
        }

        if (course.IsModular) {
            message +=
                `<br />
            <strong>Note: </strong><div style="color:red"><em>This course is a modular course. Removing ` +
                `this course will remove all courses in the module sequence.</em></div>`;
        }

        message += `<br /><br />
        Once removed, this course must be added again in order to make it an active part of ${
            self.User && self.User.IsStudent ? 'your' : 'the'
        } request list.${
            self.User && self.User.IsStudent
                ? `<br /><br />
        <strong>Note:</strong> If you course list for this term has already been approved by your school counselor, ` +
                  `this action will require your term to be re-approved by your counselor and your college advisor <u>will ` +
                  `not</u> be able to act on this term until that approval has been granted. `
                : ''
        } Are you sure you wish to continue?`;

        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'Yes - Remove',
                CancelText: 'No - CANCEL',
            })
            .subscribe((okclick) => {
                if (okclick === true) {
                    // Is this course scheduled? In other words, does it have a date scheduled,
                    // or reference # attached? If so, the current user's role MUST be
                    // a district admin role to do so, AND we must capture a reason text for
                    // doing so.
                    if (course.DateScheduled) {
                        // This course has been scheduled. Is the user a district admin?
                        if (self.User.CurrentRole !== 'DistrictAdmin') {
                            // No - warn and exit without proceeding.
                            self.dialogService
                                .OpenMessageBoxDialog({
                                    TitleText: 'Cannot Remove Course',
                                    MessageText:
                                        `The course you are attempting to remove has been ` +
                                        `previously scheduled by a college advisor or administrator. Once ` +
                                        `scheduled, the course cannot be removed. Please contact the Polk ` +
                                        `County Public Schools coordinator of Dual Enrollment services for ` +
                                        `additional information or assistance. Thank you.`,
                                    OKText: 'OK',
                                })
                                .subscribe();
                            return;
                        }

                        // User is district admin. Now collect the required explanation text.
                        self.dialogService
                            .OpenTextNoteDialog({
                                TitleText: 'Reason for Removing Course Needed',
                                MessageText:
                                    `The course you are attempting to remove has been ` +
                                    `previously scheduled by a college advisor or administrator. In order ` +
                                    `to remove this course, please provide a reason in the box provided below. ` +
                                    `Please note that this reason will be included in the Optional Comments ` +
                                    `box below the student's current dual enrollment requests list.`,
                                OKText: 'Done - Remove Course',
                                CancelText: 'Cancel',
                            })
                            .subscribe((note) => {
                                if (!note) {
                                    return; // No note means they cancelled.
                                }

                                // Have the note, we can now remove.
                                // User has opted to proceed. Signal the system to remove this request.
                                self.appService
                                    .RemoveStudentCollegeRecordCourse(
                                        self.User.AuthToken,
                                        self.User.CurrentRole,
                                        course.DualEnrollStudentID,
                                        course.CourseChoiceID,
                                        self.User.UserID
                                    )
                                    .subscribe(
                                        (courseInfo) => {
                                            // Update the request list by resetting the scope variable
                                            self.UpdateRequestsInfo(courseInfo.Requests, false);

                                            // If this is not a parent, update the notes as well.
                                            // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                                            if (self.User.CurrentRole !== 'Parent') {
                                                self.StudentScheduleNotes = courseInfo.Notes;
                                            }

                                            // Update the timeline loaded
                                            self.UpdateTimeline();

                                            // Toast success.
                                            self.splashService.SnackbarSuccess('Course removed successfully.');
                                        },
                                        (errorMsg) => {
                                            self.splashService.SnackbarError(errorMsg);
                                        }
                                    );
                            });

                        return;
                    } else {
                        // No need to check because this course isn't scheduled. Remove now.
                        // User has opted to proceed. Signal the system to remove this request.
                        self.appService
                            .RemoveStudentCollegeRecordCourse(
                                self.User.AuthToken,
                                self.User.CurrentRole,
                                course.DualEnrollStudentID,
                                course.CourseChoiceID,
                                self.User.UserID
                            )
                            .subscribe(
                                (courseInfo) => {
                                    // Update the request list by resetting the scope variable
                                    self.UpdateRequestsInfo(courseInfo.Requests, false);

                                    // If this is not a parent, update the notes as well.
                                    // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                                    if (self.User.CurrentRole !== 'Parent') {
                                        self.StudentScheduleNotes = courseInfo.Notes;
                                    }

                                    // Update the timeline loaded
                                    self.UpdateTimeline();

                                    // Toast success.
                                    self.splashService.SnackbarSuccess('Course removed successfully.');
                                },
                                (errorMsg) => {
                                    self.splashService.SnackbarError(errorMsg);
                                }
                            );
                    }
                }
            });
    }

    // #endregion

    // #region Remove Note Method

    RemoveNote(note: CollegeRecordNote) {
        const self = this;

        if (!note) {
            return;
        }

        // Get a confirmation before proceeding to set it as removed.
        const message = `Are you sure you wish to remove this note? Once removed, this note cannot be recovered.`;

        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'Yes - Remove',
                CancelText: 'No - CANCEL',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User has opted to proceed. Signal the system to remove this request.
                    self.appService
                        .RemoveStudentCollegeRecordNote(self.User.AuthToken, note.DualEnrollStudentID, note.NoteID)
                        .subscribe(
                            (notes) => {
                                // Update the notes list by resetting the variable
                                self.StudentScheduleNotes = notes;

                                // Toast success.
                                self.splashService.SnackbarSuccess('Note removed successfully.');
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Request All Approval Method

    RequestAllApproval(message: string, courses: CourseChoice[]) {
        const self = this;

        // Check to see if we have a college student ID entered. If we do not, they must set that before they can approve
        // a course, remove a course, or approve a schedule.
        if (!self.SelectedCollege.StudentCollegeID) {
            self.dialogService
                .OpenMessageBoxDialog({
                    TitleText: 'Alert',
                    IconName: 'error',
                    MessageText:
                        `This student does not have an updated College Student ID number. Please use the ` +
                        `provided "Update" button to enter the student's College Student ID number for ` +
                        `${self.SelectedCollege.CollegeName} before proceeding.`,
                })
                .subscribe((res) => {});

            return;
        }

        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message || '',
                OKText: 'YES - Approve & Mark Scheduled',
                CancelText: 'NO - Cancel',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User selected to proceed. Pass confirmation off to the service. Which one is used depends on if
                    // there are courses passed in or not.
                    let svcObs: Observable<StudentCollegeInfo[]>;

                    if (!courses || !courses.length) {
                        svcObs = self.appService.AdvisorUpdateStudentCollegeRecord(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.User.UserID,
                            self.SelectedCollege.FormStatus,
                            true,
                            null
                        );
                    } else {
                        svcObs = self.appService.AdvisorUpdateStudentCollegeRecords(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.User.UserID,
                            self.SelectedCollege.FormStatus,
                            true,
                            null,
                            courses
                        );
                    }

                    // Regardless, wait on the result.
                    svcObs.subscribe(
                        (infoList) => {
                            // Update the info in the system.
                            self.UpdateAllCollegesInfo(infoList).subscribe(
                                (success) => {
                                    self.UpdateTimeline();

                                    // Toast the successful approval
                                    self.splashService.CloseSplash();
                                    self.splashService.SnackbarSuccess(
                                        'Dual Enrollment record approved & marked as scheduled successfully.'
                                    );
                                },
                                (error) => {
                                    self.splashService.CloseSplash();
                                    self.errorService.HandleServiceError(error);
                                }
                            );
                        },
                        (error) => {
                            self.errorService.HandleServiceError(error);
                        }
                    );
                }
            });
    }

    // #endregion

    // #region Return Form Method

    ReturnForm(event: boolean) {
        const self = this;

        // Get a confirmation from the advisor.
        const totalCredits = 0;

        const message =
            `You are about to return this student's Dual Enrollment course request list to the ` +
            `school for further editing or changes:<br /><br />
        <strong>Student: </strong>${self.titleCasePipe.transform(self.SelectedStudent.LastName)}, ${self.titleCasePipe.transform(
                self.SelectedStudent.FirstName
            )}<br />
        <strong>College: </strong>${self.SelectedCollege.CollegeName} (${self.schoolYearPipe.transform(
                self.SelectedCollege.SchoolYear
            )} - ${self.collegeTermPipe.transform(self.SelectedCollege.Term.TermCode)})<br /><br />
        Please enter any comments in the box provided below that will be displayed for the school counselor ` +
            `to review in connection to this return:<br />`;

        self.dialogService
            .OpenTextNoteDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'YES - Return to School',
                CancelText: 'NO - Cancel',
            })
            .subscribe((note) => {
                if (note) {
                    // User selected to proceed. Pass confirmation off to the service.
                    self.appService
                        .AdvisorUpdateStudentCollegeRecord(
                            self.User.AuthToken,
                            self.SelectedStudent.StudentID,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.User.UserID,
                            self.SelectedCollege.FormStatus,
                            false,
                            note
                        )
                        .subscribe(
                            (infoList) => {
                                // Update the info in the system.
                                self.UpdateAllCollegesInfo(infoList).subscribe(
                                    (success) => {
                                        self.UpdateTimeline();

                                        // Toast the successful return
                                        self.splashService.CloseSplash();
                                        self.splashService.SnackbarSuccess('Dual Enrollment record returned to school successfully.');
                                    },
                                    (error) => {
                                        self.splashService.CloseSplash();
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Select College Record Method

    SelectCollegeRecord(col: StudentCollegeInfo) {
        const self = this;

        if (!col) {
            return;
        }

        // If this represents a change from the currently selected entry, update which entry is currently
        // selected, and fire the update terms call.
        if (col !== self.SelectedCollege) {
            // Turn off agreements display (in case we're switching to an older record).
            self.ShowAgreements = false;
            self.SelectedCollege = col;

            self.CollegeChangeHandler(self.SelectedCollege).subscribe(
                (success) => {
                    self.UpdateSingleCollegeInfo(col);

                    // Update the timeline loaded
                    self.UpdateTimeline();

                    self.ShowAgreements = false;

                    // Go to this state now
                    const url = self.router.createUrlTree(['/studentview', col.DualEnrollStudentID, col.StudentID]).toString();
                    self.location.go(url);
                },
                (errorMsg) => {
                    self.splashService.SnackbarError(errorMsg);

                    // Update the state parameter by transitioning to this state without a reload
                    self.router.navigate(['studentview', col.DualEnrollStudentID, col.StudentID]);
                }
            );
        }
    }

    // #endregion

    // #region Select Course Method

    SelectCourse(coursechosen: CollegeCourseInfo) {
        const self = this;

        if (!coursechosen) {
            return;
        }

        // Check to see if the course which is currently selected is already in the list of requested courses.
        // If it is, do not add it again, toaster a reminder note.
        if (self.StudentSchedule && self.StudentSchedule.length) {
            if (
                self.StudentSchedule.find((item) => {
                    return item.CollegeCourseID === coursechosen.DualEnrollCollegeCourseID && item.RemovedBy == null;
                }) != null
            ) {
                // Match already exists. Toast about it and exit.
                self.splashService.SnackbarError('Course already exists in list of requested courses.');
                return;
            }
            if (
                self.StudentSchedule.find((item) => {
                    return item.CollegeCourseID === coursechosen.DualEnrollCollegeCourseID && item.RemovedBy != null;
                }) != null
            ) {
                // Match already exists from removed courses. Toast about it and exit.
                self.splashService.SnackbarError('Course already exists and was previously removed. Please check the checkbox to show removed courses to undo the removed course.');
                return;
            }
        }

        // Send a request to the system to add this course, which will in turn refresh the table of requested courses.
        self.appService
            .AddStudentCollegeRecordCourse(
                self.User.AuthToken,
                self.SelectedCollege.DualEnrollStudentID,
                coursechosen.DualEnrollCollegeCourseID,
                self.User.UserID,
                coursechosen.PriorityRequest
            )
            .subscribe(
                (info) => {
                    const courses = info && info.Requests;

                    // Update the request list by resetting the scope variable
                    self.UpdateRequestsInfo(courses, coursechosen.Prefix === 'MAC' && coursechosen.Code === '1105');

                    // If this is not a student, update the notes list by resetting the scope variable
                    // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                    if (self.User.CurrentRole !== 'Parent') {
                        self.StudentScheduleNotes = info.Notes;
                    }

                    // Toast the addition.
                    self.splashService.SnackbarSuccess('Course request added successfully.');

                    // If the current form status is anything more than 3 (making course choices), then we should
                    // refresh the overall college requests since the form status likely changed as a result of this action.
                    if (self.SelectedCollege.FormStatus > 3) {
                        // Update the master list.
                        self.appService.GetStudentCollegeInformation(self.User.AuthToken, self.SelectedStudent.StudentID).subscribe(
                            (infoList) => {
                                self.UpdateAllCollegesInfo(infoList).subscribe(
                                    (done) => {
                                        // Update the timeline loaded
                                        self.UpdateTimeline();
                                    },
                                    (errorMsg: string) => {
                                        self.splashService.SnackbarError(errorMsg);
                                    }
                                );
                            },
                            (errorMsg: string) => {
                                // Error message will be caught by the master $q all reference
                                self.splashService.SnackbarError(errorMsg);
                            }
                        );
                    }
                },
                (errorMsg: string) => {
                    self.splashService.SnackbarError(errorMsg);
                }
            );
    }

    // #endregion

    // #region Set Course Reference Number

    SetCourseReferenceNumber(course: CourseChoice) {
        const self = this;

        if (!course) {
            return;
        }

        // Get the course reference number from a dialog (or a check stating it is taught at the county schools).
        const message =
            `Please provide the Course Reference Number for the course/section that is being requested into in the box provided below. If this course is being taught at a Polk County School District ` +
            `school, please check the provided checkbox and do not provide a reference number.<br /><br />
        <strong>Prefix: </strong>${course.Prefix}<br />
        <strong>Code: </strong>${course.Code}<br />
        <strong>Name: </strong>${course.Name}`;

        self.dialogService
            .OpenScheduleCourseDialog({
                TitleText: `${course.ReferenceNumber ? 'Update' : 'Set'} Course Reference Number`,
                MessageText: message,
                OKText: `${course.ReferenceNumber ? 'Update' : 'Set'}`,
                CancelText: 'CANCEL',
                ReferenceNumber: course.ReferenceNumber,
                CountyTaught: course.CountyTaught,
            })
            .subscribe((result) => {
                if (result != null) {
                    // User has opted to proceed. Using the provided values, update the course reference number for the requested course.
                    self.splashService
                        .DisplaySplash({
                            TitleText: 'Please wait',
                            MessageText: `${course.ReferenceNumber ? 'Updating' : 'Setting'} Course Reference Number...`,
                        })
                        .pipe(takeUntil(self._subRelease))
                        .subscribe(() => {
                            self.appService
                                .UpdateStudentCollegeRecordCourseReferenceNumber(
                                    self.User.AuthToken,
                                    course.DualEnrollStudentID,
                                    course.CourseChoiceID,
                                    self.User.UserID,
                                    result.ReferenceNumber,
                                    result.CountyTaught
                                )
                                .subscribe(
                                    (info) => {
                                        const courses = info && info.Requests;

                                        // Update the request list by resetting the variable
                                        self.UpdateRequestsInfo(courses, false);

                                        // If this is not a student, update the notes list by resetting the scope variable
                                        // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                                        if (self.User.CurrentRole !== 'Parent') {
                                            self.StudentScheduleNotes = info.Notes;
                                        }

                                        // Update the timeline loaded
                                        self.UpdateTimeline();

                                        // Drop the splash.
                                        self.splashService.CloseSplash();

                                        // Toast success.
                                        self.splashService.SnackbarSuccess(
                                            `Course Reference Number ${course.ReferenceNumber ? 'Updated' : 'Set'} Successfully.`
                                        );
                                    },
                                    (error) => {
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                        });
                }
            });
    }

    // #endregion

    // #region Set Course Alt Reference Number

    SetCourseAltReferenceNumber(course: CourseChoice) {
        const self = this;

        if (!course) {
            return;
        }

        // Get the course alternative reference number from a dialog.
        const message = `Please provide the Course Alternative Section Reference Number for the course that is being requested into in the box provided below.<br /><br />
        <strong>Prefix: </strong>${course.Prefix}<br />
        <strong>Code: </strong>${course.Code}<br />
        <strong>Name: </strong>${course.Name}`;

        self.dialogService
            .OpenScheduleCourseDialog({
                TitleText: `${course.AltReferenceNumber ? 'Update' : 'Set'} Course Alternative Section Reference Number`,
                MessageText: message,
                OKText: `${course.AltReferenceNumber ? 'Update' : 'Set'}`,
                CancelText: 'CANCEL',
                ReferenceNumber: course.AltReferenceNumber,
                IsForAltReference: true,
            })
            .subscribe((result) => {
                if (result != null) {
                    // User has opted to proceed. Using the provided values, update the course alt reference number for the requested course.
                    self.splashService
                        .DisplaySplash({
                            TitleText: 'Please wait',
                            MessageText: `${
                                course.AltReferenceNumber ? 'Updating' : 'Setting'
                            } Course Alternative Section Reference Number...`,
                        })
                        .pipe(takeUntil(self._subRelease))
                        .subscribe(() => {
                            self.appService
                                .UpdateStudentCollegeRecordCourseAltReferenceNumber(
                                    self.User.AuthToken,
                                    course.DualEnrollStudentID,
                                    course.CourseChoiceID,
                                    self.User.UserID,
                                    result.ReferenceNumber
                                )
                                .subscribe(
                                    (info) => {
                                        const courses = info && info.Requests;

                                        // Update the request list by resetting the variable
                                        self.UpdateRequestsInfo(courses, false);

                                        // If this is not a student, update the notes list by resetting the scope variable
                                        // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                                        if (self.User.CurrentRole !== 'Parent') {
                                            self.StudentScheduleNotes = info.Notes;
                                        }

                                        // Update the timeline loaded
                                        self.UpdateTimeline();

                                        // Drop the splash.
                                        self.splashService.CloseSplash();

                                        // Toast success.
                                        self.splashService.SnackbarSuccess(
                                            `Course Alternative Section Reference Number ${
                                                course.AltReferenceNumber ? 'Updated' : 'Set'
                                            } Successfully.`
                                        );
                                    },
                                    (error) => {
                                        self.errorService.HandleServiceError(error);
                                    }
                                );
                        });
                }
            });
    }

    // #endregion

    // #region Set Dual Enrollment Program Method

    SetDualEnrollmentProgram() {
        const self = this;

        // Check to make sure that we have both required components: A dual enrollment program selection,
        // and if necessary, an accelerated degree program. This is a failsafe as this shouldn't be called unless both are present.
        if (self.DualEnrollmentProgramChoice == null) {
            self.splashService.SnackbarError('Please choose a Dual Enrollment Program.');
            return;
        }
        if (self.DualEnrollmentProgramChoice === 3 && self.AcceleratedDegreeProgramChoice == null) {
            self.splashService.SnackbarError('Please choose an Accelerated Degree Program.');
            return;
        }

        // Send off the request to the system.
        const message = `You are about to set this student's Dual Enrollment Program choice as follows:<br /><br />
        <strong>Program:</strong> ${self.dualEnrollmentProgramPipe.transform(self.DualEnrollmentProgramChoice)}${
            self.DualEnrollmentProgramChoice === 3
                ? '<br /><strong>Degree Program:</strong> ' +
                  self.acceleratedDegreeProgramPipe.transform(self.AcceleratedDegreeProgramChoice)
                : ''
        }<br /><br />Are you sure you wish to continue?`;

        // Get a confirmation.
        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'Yes - Set Program',
                CancelText: 'No - CANCEL',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User has opted to continue. Call the server to process the setting.
                    self.appService
                        .UpdateStudentProgram(
                            self.User.AuthToken,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.DualEnrollmentProgramChoice,
                            self.AcceleratedDegreeProgramChoice
                        )
                        .subscribe(
                            (collegeinfo) => {
                                // Find the correct entry in the list of all known college data, then replace that entry
                                // with the one just returned, and update the SelectedCollege property.
                                if (self.StudentCollegeInfo && self.StudentCollegeInfo.length) {
                                    const entryIdx = self.StudentCollegeInfo.findIndex((item) => {
                                        return item.DualEnrollStudentID === collegeinfo.DualEnrollStudentID;
                                    });
                                    if (entryIdx >= 0) {
                                        self.StudentCollegeInfo[entryIdx] = collegeinfo;
                                        self.SelectedCollege = null;

                                        self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

                                        if (self.FilteredStudentCollegeInfo) {
                                            const entry = self.FilteredStudentCollegeInfo.find((item) => {
                                                return item.DualEnrollStudentID === collegeinfo.DualEnrollStudentID;
                                            });
                                            self.SelectedCollege = entry;
                                        }

                                        if (
                                            !self.SelectedCollege &&
                                            self.FilteredStudentCollegeInfo &&
                                            self.FilteredStudentCollegeInfo.length
                                        ) {
                                            self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                        }

                                        self.UpdateDesigneeRights();
                                    }
                                }

                                // Toast the successful update
                                self.splashService.SnackbarSuccess('Dual Enrollment Program Update Successful.');

                                // Refresh/Load the courses for this college and term.
                                self.appService
                                    .GetAllCoursesAtCollege(
                                        self.User.AuthToken,
                                        self.SelectedCollege.CollegeID,
                                        self.SelectedCollege.CollegeSchoolYear
                                    )
                                    .subscribe(
                                        (courseIdx) => {
                                            if (courseIdx != null) {
                                                self.SelectedCollegeDepartments =
                                                    self.appService.CollegeCourses[courseIdx].Departments;
                                                self.SelectedCollegeCourses = self.appService.CollegeCourses[courseIdx].Courses;
                                            }
                                        },
                                        (error) => {
                                            self.errorService.HandleServiceError(error);
                                        }
                                    );

                                // Update timeline
                                self.UpdateTimeline();
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Set Timeline Steps Method

    SetTimelineSteps() {
        const self = this;

        if (!self.User) {
            return;
        }

        if (self.User.IsStudent) {
            self.Steps = [
                {
                    Tooltip: 'Step 1: Agree to terms and conditions',
                    Description: 'Waiting for you to agree to Terms and Conditions for Dual Enrollment participation...',
                    NextStep: 'Read, review, and agree to the Terms and Conditions for Dual Enrollment participation.',
                    Warning:
                        '<span style="color:red">Note:</span> Do <strong>not</strong> visit with your college advisor at this time.',
                },
                {
                    Tooltip: 'Step 2: Counselor selects Dual Enrollment program',
                    Description: 'Waiting for counselor to certify a Dual Enrollment program selection...',
                    NextStep: 'Meet with your school counselor to discuss Dual Enrollment program options.',
                    Warning:
                        '<span style="color:red">Note:</span> Do <strong>not</strong> visit with your college advisor at this time.',
                },
                {
                    Tooltip: 'Step 3: Select courses for term & counselor approves requests',
                    Description: 'Selecting courses for the college term...',
                    NextStep:
                        'Complete your course choices and visit your school counselor to have him/her approve your course choices.',
                    Warning:
                        '<span style="color:red">Note:</span> Do <strong>not</strong> visit with your college advisor at this time.',
                },
                {
                    Tooltip: 'Step 4: Have parent agree to terms and conditions',
                    Description: 'Waiting for your parent to agree to Terms and Conditions for Dual Enrollment participation...',
                    NextStep:
                        `Ask your parent to log into DELTA and read, review, and agree to the Terms and Conditions ` +
                        `for Dual Enrollment participation.`,
                    Warning:
                        '<span style="color:red">Note:</span> Do <strong>not</strong> visit with your college advisor at this time.',
                },
                {
                    Tooltip: 'Step 5: School administrator approves requests',
                    Description: 'Waiting for school admin to approve your course requests...',
                    NextStep: 'Gather any paperwork you will need to complete your Dual Enrollment registration.',
                    Warning:
                        '<span style="color:red">Note:</span> Do <strong>not</strong> visit with your college advisor at this time.',
                },
                {
                    Tooltip: 'Step 6: College advisor approves requests',
                    Description: 'Waiting for your college advisor to approve your course requests...',
                    NextStep: 'Visit your college and meet with your college advisor to schedule your courses.',
                    Warning:
                        `<span style="color:red;text-transform:uppercase">Note:</span> Be sure to take all ` +
                        `paperwork you'll need with you to the college and drive safely!`,
                },
                {
                    Tooltip: 'Done!',
                    Description: 'Congratulations! Your Dual Enrollment term record has been scheduled by your college advisor.',
                    NextStep: 'Enjoy your classes!',
                },
            ];
            return;
        } else if (self.User.IsCounselor) {
            self.Steps = [
                {
                    Tooltip: 'Step 1: Agree to terms and conditions',
                    Description: 'Waiting for the student to agree to Terms and Conditions for Dual Enrollment participation...',
                    NextStep:
                        'The student should read, review, and agree to the Terms and Conditions for Dual Enrollment participation.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit ` +
                        `with his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 2: Counselor selects Dual Enrollment program',
                    Description: 'Waiting for counselor to certify a Dual Enrollment program selection...',
                    NextStep:
                        `Review the student's test scores, current scholastic record, and available Dual Enrollment programs ` +
                        `and discuss/select a Dual Enrollment program for the student.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 3: Select courses for term & counselor approves requests',
                    Description: 'Waiting for student to select courses for the college term...',
                    NextStep: 'The student should complete his/her course choices and visit with you to approve their course choices.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 4: Have parent agree to terms and conditions',
                    Description: `Waiting for the student's parent to agree to Terms and Conditions for Dual Enrollment participation...`,
                    NextStep:
                        `Ask the student's parent to log into DELTA and read, review, and agree to the Terms and Conditions ` +
                        `for Dual Enrollment participation.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 5: School administrator approves requests',
                    Description: `Waiting for student's school admin to approve his/her course requests...`,
                    NextStep:
                        'The student should gather any paperwork he/she will need to complete his/her Dual Enrollment registration.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 6: College advisor approves requests',
                    Description: `Waiting for the student's college advisor to approve his/her course requests...`,
                    NextStep:
                        'Have the student visit his/her college and meet with his/her college advisor to schedule his/her courses.',
                    Warning:
                        `<span style="color:red;text-transform:uppercase">Note:</span> The student should be sure ` +
                        `to take all paperwork he/she will need with him/her to the college and drive safely!`,
                },
                {
                    Tooltip: 'Done!',
                    Description:
                        `Congratulations! The student's Dual Enrollment term record has been scheduled ` +
                        `by his/her college advisor.`,
                },
            ];
            return;
        } else if (self.User.IsSchoolAdmin) {
            self.Steps = [
                {
                    Tooltip: 'Step 1: Agree to terms and conditions',
                    Description: 'Waiting for the student to agree to Terms and Conditions for Dual Enrollment participation...',
                    NextStep:
                        'The student should read, review, and agree to the Terms and Conditions for Dual Enrollment participation.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit ` +
                        `with his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 2: Counselor selects Dual Enrollment program',
                    Description: 'Waiting for counselor to certify a Dual Enrollment program selection...',
                    NextStep: 'The student should meet with his/her school counselor to discuss Dual Enrollment program options.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 3: Select courses for term & counselor approves requests',
                    Description: 'Waiting for student and counselor to select courses for the college term...',
                    NextStep:
                        `The student should complete his/her course choices and visit his/her school counselor to have ` +
                        `him/her approve their course choices.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with his/her ` +
                        `college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 4: Have parent agree to terms and conditions',
                    Description: `Waiting for the student's parent to agree to Terms and Conditions for Dual Enrollment participation...`,
                    NextStep:
                        `Ask the student's parent to log into DELTA and read, review, and agree to the Terms and ` +
                        `Conditions for Dual Enrollment participation.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with his/her ` +
                        `college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 5: School administrator approves requests',
                    Description: `Waiting for student's school admin to approve his/her course requests...`,
                    NextStep:
                        `Review the student's test scores, scholastic record, and course requests before approving ` +
                        `the request. The student should also gather any paperwork he/she will need to complete his/her` +
                        ` Dual Enrollment registration.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 6: College advisor approves requests',
                    Description: `Waiting for the student's college advisor to approve his/her course requests...`,
                    NextStep:
                        'Have the student visit his/her college and meet with his/her college advisor to schedule his/her courses.',
                    Warning:
                        `<span style="color:red;text-transform:uppercase">Note:</span> The student should be ` +
                        `sure to take all paperwork he/she will need with him/her to the college and drive safely!`,
                },
                {
                    Tooltip: 'Done!',
                    Description:
                        `Congratulations! The student's Dual Enrollment term record has been scheduled ` +
                        `by his/her college advisor.`,
                },
            ];
        } else if (self.User.IsAdvisor || self.User.IsCollegeAdmin || self.User.IsCollegeSupport) {
            self.Steps = [
                {
                    Tooltip: 'Step 1: Agree to terms and conditions',
                    Description: 'Waiting for the student to agree to Terms and Conditions for Dual Enrollment participation...',
                },
                {
                    Tooltip: 'Step 2: Counselor selects Dual Enrollment program',
                    Description: 'Waiting for school counselor to certify a Dual Enrollment program selection...',
                },
                {
                    Tooltip: 'Step 3: Select courses for term & counselor approves requests',
                    Description: 'Waiting for student and counselor to select courses for the college term...',
                },
                {
                    Tooltip: 'Step 4: Have parent agree to terms and conditions',
                    Description: `Waiting for the student's parent to agree to Terms and Conditions for Dual Enrollment participation...`,
                },
                {
                    Tooltip: 'Step 5: School administrator approves requests',
                    Description: `Waiting for school admin to approve the student's course requests...`,
                },
                {
                    Tooltip: 'Step 6: College advisor approves requests',
                    Description: `Waiting for you to approve/schedule the student's course requests...`,
                    NextStep: 'Review student test scores and course requests, along with any optional notes provided by the school.',
                },
                { Tooltip: 'Done!', Description: `Congratulations! The student's Dual Enrollment term record has been scheduled.` },
            ];
        } else if (self.User.IsDistrictAdmin || self.User.IsDeveloper) {
            self.Steps = [
                {
                    Tooltip: 'Step 1: Agree to terms and conditions',
                    Description: 'Waiting for the student to agree to Terms and Conditions for Dual Enrollment participation...',
                    NextStep:
                        'The student should read, review, and agree to the Terms and Conditions for Dual Enrollment participation.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 2: Counselor selects Dual Enrollment program',
                    Description: 'Waiting for counselor to certify a Dual Enrollment program selection...',
                    NextStep: 'The student should meet with his/her school counselor to discuss Dual Enrollment program options.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 3: Select courses for term & counselor approves requests',
                    Description: 'Waiting for student and counselor to select courses for the college term...',
                    NextStep:
                        `The student should complete his/her course choices and visit his/her school counselor to have ` +
                        `him/her approve their course choices.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 4: Have parent agree to terms and conditions',
                    Description: `Waiting for the student's parent to agree to Terms and Conditions for Dual Enrollment participation...`,
                    NextStep:
                        `Ask the student's parent to log into DELTA and read, review, and agree to the Terms and ` +
                        `Conditions for Dual Enrollment participation.`,
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 5: School administrator approves requests',
                    Description: `Waiting for student's school admin to approve his/her course requests...`,
                    NextStep:
                        'The student should gather any paperwork he/she will need to complete his/her Dual Enrollment registration.',
                    Warning:
                        `<span style="color:red">Note:</span> The student should <strong>not</strong> visit with ` +
                        `his/her college advisor at this time.`,
                },
                {
                    Tooltip: 'Step 6: College advisor approves requests',
                    Description: `Waiting for the student's college advisor to approve his/her course requests...`,
                    NextStep:
                        'Have the student visit his/her college and meet with his/her college advisor to schedule his/her courses.',
                    Warning:
                        `<span style="color:red;text-transform:uppercase">Note:</span> The student should be sure to ` +
                        `take all paperwork he/she will need with him/her to the college and drive safely!`,
                },
                {
                    Tooltip: 'Done!',
                    Description:
                        `Congratulations! The student's Dual Enrollment term record has been scheduled ` +
                        `by his/her college advisor.`,
                },
            ];
        } else {
            self.Steps = [];
        }
    }

    // #endregion

    // #region Show Status Explanation Method

    ShowStatusExplanation(status: number) {
        const self = this;

        const explain = self.formStatusPipe.transform(status, true);

        // Pop up the dialog
        self.dialogService
            .OpenMessageBoxDialog({
                TitleText: 'Information',
                MessageText: explain,
                OKText: 'OK',
            })
            .subscribe((result) => {});
    }

    // #endregion

    // #region Student Submit Approval Method

    StudentSubmitApproval() {
        const self = this;

        // Get approval for this process
        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: `You are about to transmit your acceptance of the terms and conditions for ${
                    self.SelectedCollege.CollegeName
                } for the ${self.collegeTermPipe
                    .transform(self.SelectedCollege.Term.TermCode)
                    .toProperCase()} (${self.extendedCollegeTermPipe.transform(
                    self.SelectedCollege.Term,
                    self.SelectedCollege.CollegeID
                )}) Term. Are you sure?`,
                OKText: 'Yes',
                CancelText: 'No - Cancel',
            })
            .subscribe((yes) => {
                if (yes === true) {
                    // Signal approval to the system for the college currently selected, along with the county one as well by default.
                    self.appService
                        .ApproveTermsAgreements(
                            self.User.AuthToken,
                            self.User.StudentID,
                            self.SelectedCollege.CollegeID,
                            self.SelectedCollege.SchoolYear,
                            self.SelectedCollege.Term.TermWindowID
                        )
                        .subscribe(
                            (terms) => {
                                // Both the county and the college terms were set as approved. Now, to be safe, we will requery
                                // for the current terms for the student and this will update the flag in the selected college
                                // entry to show it was accepted, which will drive the UI to update.
                                self.appService
                                    .GetStudentCollegeInformation(self.User.AuthToken, self.SelectedStudent.StudentID)
                                    .subscribe(
                                        (infoList) => {
                                            // Update the master list to reflect this provided update list.
                                            const curCollege = self.SelectedCollege.DualEnrollStudentID;
                                            self.SelectedCollege = null;

                                            self.UpdateAllCollegesInfo(infoList).subscribe(
                                                (success) => {
                                                    // Update the selected college if we now only have a single record available.
                                                    if (self.FilteredStudentCollegeInfo && self.FilteredStudentCollegeInfo.length) {
                                                        self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                                    } else {
                                                        // Try to reset the existing one before this call updated.
                                                        self.SelectedCollege = self.FilteredStudentCollegeInfo.find((item) => {
                                                            return item.DualEnrollStudentID === curCollege;
                                                        });

                                                        if (
                                                            !self.SelectedCollege &&
                                                            self.FilteredStudentCollegeInfo &&
                                                            self.FilteredStudentCollegeInfo.length
                                                        ) {
                                                            self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                                        }
                                                    }

                                                    self.UpdateDesigneeRights();

                                                    self.UpdateTimeline();

                                                    self.splashService.CloseSplash();
                                                    self.splashService.SnackbarSuccess(
                                                        'Acceptance of terms transmitted successfully.'
                                                    );
                                                },
                                                (errorMsg: string) => {
                                                    self.splashService.CloseSplash();
                                                    self.splashService.SnackbarError(errorMsg);
                                                }
                                            );
                                        },
                                        (errorMsg: string) => {
                                            self.splashService.CloseSplash();
                                            self.splashService.SnackbarError(errorMsg);
                                        }
                                    );
                            },
                            (errorMsg: string) => {
                                self.splashService.SnackbarError(errorMsg);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Toggle Agreements Method

    ToggleAgreements(col: StudentCollegeInfo) {
        const self = this;
        if (!col) {
            return;
        }

        // Get the true matching entry in the FilteredStudents set
        const actualCol = self.FilteredStudentCollegeInfo.find((item) => {
            return item.DualEnrollStudentID === col.DualEnrollStudentID;
        });

        if (self.ShowAgreements !== true) {
            // Show the agreements. If we've previously loaded agreements for the selected college and the
            // county, then we can proceed by showing the panel. Otherwise, we must load those now.
            let countyObs: Observable<CollegeAgreement>;
            let collegeObs: Observable<CollegeAgreement>;

            if (!self.PCSBAgreementText) {
                // Call the system to load the county agreement text object. If flags indicate the agreement
                // has already been made, we retrieve the version agreed to for display based upon the term and
                // college. Otherwise, we simply get the most recent/current version instead.
                if (
                    (!self.User.IsParent && actualCol.StudentPolkAgreementApproved === true) ||
                    (self.User.IsParent && actualCol.ParentHasApproved === true && actualCol.ParentApprovedUser === self.User.UserID)
                ) {
                    // Previously approved - Get the version approved.
                    countyObs = self.appService.GetAgreementApprovalText(
                        self.User.AuthToken,
                        1,
                        actualCol.Term.TermWindowID,
                        actualCol.StudentID
                    );
                } else {
                    // Not yet approved - Get the current agreement text
                    countyObs = self.appService.GetCollegeAgreementText(self.User.AuthToken, 1);
                }
            } else {
                // Already have it - simply pass it back along
                countyObs = empty().pipe(
                    startWith(<CollegeAgreement>{
                        Text: self.PCSBAgreementText,
                        DateCreated: self.PCSBAgreementDate,
                        ConsentText: self.PCSBAgreementConsentText,
                    })
                );
            }

            // Now, the college.
            if (!actualCol.AgreementText) {
                // Call the system to load the college agreement text object. If flags indicate the agreement has
                // already been made, we retrieve the version agreed to for display based upon the term and college.
                // Otherwise, we simply get the most recent/current version instead.
                if (
                    (!self.User.IsParent && actualCol.StudentCollegeAgreementApproved === true) ||
                    (self.User.IsParent && actualCol.ParentHasApproved === true && actualCol.ParentApprovedUser === self.User.UserID)
                ) {
                    // Previously approved - Get the version approved.
                    collegeObs = self.appService.GetAgreementApprovalText(
                        self.User.AuthToken,
                        actualCol.CollegeID,
                        actualCol.Term.TermWindowID,
                        actualCol.StudentID
                    );
                } else {
                    // Not yet approved - Get the current agreement text
                    collegeObs = self.appService.GetCollegeAgreementText(self.User.AuthToken, actualCol.CollegeID);
                }
            } else {
                // Already have it - simply pass it back along
                collegeObs = empty().pipe(
                    startWith(<CollegeAgreement>{
                        Text: actualCol.AgreementText,
                        DateCreated: actualCol.AgreementTextDate,
                        ConsentText: actualCol.AgreementConsentText,
                    })
                );
            }

            // When we have both...
            zip(countyObs, collegeObs, function (county, college) {
                return {
                    County: county,
                    College: college,
                };
            })
                .pipe(takeUntil(self._subRelease))
                .subscribe(
                    (results) => {
                        if (results.County) {
                            self.PCSBAgreementText = results.County.Text;
                            self.PCSBAgreementDate = results.County.DateCreated;
                            self.PCSBAgreementConsentText = results.County.ConsentText;
                        }
                        if (results.College) {
                            actualCol.AgreementText = results.College.Text;
                            actualCol.AgreementTextDate = results.College.DateCreated;
                            actualCol.AgreementConsentText = results.College.ConsentText;
                        }

                        // Lock the checkboxes
                        self.AgreementChecks = self.AgreementChecks || { PCSBAgreed: false, CollegeAgreed: false };
                        self.AgreementChecks.PCSBAgreed = !self.User.IsParent
                            ? actualCol.StudentPolkAgreementApproved
                            : actualCol.ParentHasApproved;
                        self.AgreementChecks.CollegeAgreed = !self.User.IsParent
                            ? actualCol.StudentCollegeAgreementApproved
                            : actualCol.ParentHasApproved;

                        self.ShowAgreements = true;
                    },
                    (errorMsg: string) => {
                        self.errorService.HandleServiceError(errorMsg);
                    }
                );
        } else {
            // We are hiding the agreements block.
            self.ShowAgreements = false;
        }
    }

    // #endregion

    // #region Toggle Test History Method

    ToggleTestHistory() {
        this.ShowTestHistory = !this.ShowTestHistory;
    }

    // #endregion

    // #region Undo Remove Course Method

    UndoRemoveCourse(course: CourseChoice) {
        const self = this;

        if (!course) {
            return;
        }

        // Check to see if we have a college student ID entered. If we do not, they must set that before they can approve
        // a course, remove a course, or approve a schedule.
        if (self.User && (self.User.IsAdvisor || self.User.IsCollegeAdmin) && !self.SelectedCollege.StudentCollegeID) {
            self.dialogService
                .OpenMessageBoxDialog({
                    TitleText: 'Alert',
                    IconName: 'error',
                    MessageText:
                        `This student does not have an updated College Student ID number. Please use the ` +
                        `provided "Update" button above to enter the student's College Student ID number for ` +
                        `${self.SelectedCollege.CollegeName} before proceeding.`,
                })
                .subscribe(() => {});

            return;
        }

        // Get a confirmation before proceeding to undo setting it as removed.
        const message = `You have chosen to undo the removal of the following course from the request list for ${
            self.SelectedCollege.CollegeName
        } (${self.collegeTermPipe.transform(self.SelectedCollege.Term.TermCode)} ${self.schoolYearPipe.transform(
            self.SelectedSchoolYear
        )})<br /><br />
        <strong>Prefix: </strong>${course.Prefix}<br />
        <strong>Code: </strong>${course.Code}<br />
        <strong>Name: </strong>${course.Name}<br />
        <strong>Reference Number: </strong>${
            (course.ReferenceNumber || '') +
            (course.ReferenceNumber != null && course.ReferenceNumber !== ''
                ? `<br /><div style="color:red;font-size:9pt"><em>This course has previously been marked as ` +
                  `scheduled. Once this course is returned to the list, please update the reference number as ` +
                  `necessary using the provided "Update" button.</em></div>`
                : '')
        }<br /><br />
        Once undone, this course will be returned to the active part of the request list. Are you sure you wish to continue?`;

        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'Yes - Undo Remove',
                CancelText: 'No - CANCEL',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User has opted to proceed. Signal the system to undo the remove of this request.
                    self.appService
                        .UndoRemoveStudentCollegeRecordCourse(
                            self.User.AuthToken,
                            course.DualEnrollStudentID,
                            course.CourseChoiceID,
                            self.User.UserID
                        )
                        .subscribe(
                            (requests) => {
                                // Update the request list by resetting the variable
                                self.UpdateRequestsInfo(requests, course.Prefix === 'MAC' && course.Code === '1105');

                                // Update the timeline loaded
                                self.UpdateTimeline();

                                // Toast success.
                                self.splashService.SnackbarSuccess('Course removal undone successfully.');
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    // #endregion

    // #region Update College Choice Method

    UpdateStudentCollegeRecord(col: StudentCollegeInfo) {
        const self = this;

        // Toss up a splash on the screen.
        self.splashService
            .DisplaySplash({
                TitleText: 'Please wait',
                MessageText: 'Updating college record...',
            })
            .subscribe((result) => {
                // Pull together the current college record and call the system to update this record, which also generates a refresh
                // of the entire record for this student in the system.
                self.appService
                    .UpdateStudentCollegeRecord(
                        self.User.AuthToken,
                        self.User && self.User.IsStudent ? self.User.StudentID : col.StudentID,
                        col.DualEnrollStudentID,
                        col.CounselorSAPID,
                        col.FormStatus
                    )
                    .subscribe(
                        (infoList) => {
                            // Update the master list to reflect this provided update list.
                            self.UpdateAllCollegesInfo(infoList).subscribe(
                                (success) => {
                                    self.UpdateTimeline();

                                    self.splashService.CloseSplash();
                                    self.splashService.SnackbarSuccess('Record updated successfully.');
                                },
                                (errorMsg: string) => {
                                    self.splashService.CloseSplash();
                                    self.splashService.SnackbarError(errorMsg);
                                }
                            );
                        },
                        (errorMsg: string) => {
                            self.splashService.CloseSplash();
                            self.splashService.SnackbarError(errorMsg);
                        }
                    );
            });
    }

    // #endregion

    // #region Update College Student ID Method

    UpdateCollegeStudentID() {
        const self = this;

        // Use an input dialog box to collect the new student ID.
        const prompt = `Enter the student's assigned ${self.SelectedCollege.CollegeName} student ID number in the box below:`;

        self.dialogService
            .OpenUpdateCollegeIDDialog({
                TitleText: 'Update College ID',
                MessageText: prompt,
                OKText: 'Done',
                CancelText: 'Cancel',
                InputHint: 'College Student ID',
                Value: self.SelectedCollege.StudentCollegeID,
                Validators: [this.UpdateCollegeStudentIDValidator(self.SelectedCollege.CollegeID)]
            })
            .subscribe((result) => {
                if (result) {
                    // Send the given college student ID to the database for updating.
                    this.appService
                        .UpdateStudentCollegeStudentID(
                            self.User.AuthToken,
                            self.SelectedCollege.CollegeID,
                            self.SelectedStudent.StudentID,
                            result
                        )
                        .subscribe(
                            (newid) => {
                                // The return success result is the assigned college student id. It should match what was provided.
                                // Update the visible record with this value.
                                self.SelectedCollege.StudentCollegeID = newid;

                                self.splashService.SnackbarSuccess('College Student ID updated successfully.');
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                }
            });
    }

    UpdateCollegeStudentIDValidator(collegeID: number): ValidatorFn {
        // Simple RFC 5322-compliant regex for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const PCSregex = /^[a-zA-Z0-9]{9}$/;
        const SEUregex = /^[0-9]{7}$/;

        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            const hasAlpha = /[a-zA-Z]+/.test(value);
            const hasNumeric = /[0-9]+/.test(value);

            if (!value) {
                return null;
            }

            // Check if value matches email pattern
            const isEmail = emailRegex.test(value);

            if (isEmail) {
                return { matchingEmail: true }
            }           
            
            // Check if value matches college specific validation requirements
            switch (collegeID) {
                case 2:
                    // PSC Student ID is 9 alpha-numeric characters--i.e. A00143366
                    return PCSregex.test(value) ? null : { PSCInvalidID: true }
                case 4:
                    // SEU Student ID is 7 digits--i.e. 1224722
                    return SEUregex.test(value) ? null : { SEUInvalidID: true }
                default:
                    return null
            }
        }; 
    }

    // #endregion

    // #region Update Designee Rights Method

    UpdateDesigneeRights() {
        const self = this;

        if (self.User.CurrentRole !== 'Counselor' || !self.SelectedCollege || !self.SelectedCollege.SchoolNumber) {
            self.CanBypassAdmin = false;
            return;
        }

        const found = self.DesigneeCounselorRights.filter((item) => {
            return item.CanBypassAdmin === true && item.WorkLocation === self.SelectedCollege.SchoolNumber;
        });

        self.CanBypassAdmin = found && !!found.length;
    }

    // #endregion

    // #region Update All Colleges Information Method

    UpdateAllCollegesInfo(infoList: StudentCollegeInfo[]) {
        const self = this;
        const agreementsObs: Subject<void> = new Subject<void>();

        return Observable.create((finalObs: Observer<boolean>) => {
            // First, store the list of returned DE term requests.
            self.StudentCollegeInfo = infoList;
            self.UpdateFilteredList(infoList, self.SelectedSchoolYear);

            // Now, we need to try and determine a proper record to select (if possible).
            self.SelectedCollege = null;

            // If we have a known college record ID (optimal), we know exactly which entry must be pre-selected.
            // Otherwise, we will need to hope for a college ID, term,
            // and school year for this information.
            if (self.FilteredStudentCollegeInfo && self.FilteredStudentCollegeInfo.length) {
                if (self.Params_RecordID) {
                    // Best option: Simply locate the record matching this record id number.
                    self.SelectedCollege = self.FilteredStudentCollegeInfo.find((item) => {
                        return item.DualEnrollStudentID === self.Params_RecordID;
                    });

                    // Double check to make sure the school year of this college matches our currently selected school
                    // year. If there's a mismatch, we need to reset the currently selected school year since URL parameters
                    // always take precedence. However, should the newly selected college record be for a fall term for the
                    // following year, the currently selected school year can remain mismatched.
                    if (
                        self.SelectedCollege &&
                        self.SelectedCollege.SchoolYear !== self.SelectedSchoolYear &&
                        self.SelectedCollege.Term &&
                        self.SelectedCollege.Term.TermCode === '1'
                    ) {
                        // Potential Fall record. Need to check to ensure the school year is a single year after.
                        // If it isn't, go ahead and update the selected year.
                        if (!self.IsNextSchoolYear(self.SelectedSchoolYear, self.SelectedCollege.SchoolYear)) {
                            self.appService.SelectedSchoolYear = self.SelectedCollege.SchoolYear;
                        }
                    }
                }

                if (!self.SelectedCollege && self.Params_CollegeID && self.Params_Term) {
                    // Next best: Locate a record with the same college ID number, term, and school year.
                    self.SelectedCollege = self.FilteredStudentCollegeInfo.find((item) => {
                        return item.CollegeID === self.Params_CollegeID && item.Term && item.Term.TermCode === self.Params_Term;
                    });
                }

                if (!self.SelectedCollege && self.SelectedSchoolYear) {
                    // Next best: Locate a record with the same school year as the school year in the params.
                    self.SelectedCollege = self.FilteredStudentCollegeInfo.find((item) => {
                        return item.SchoolYear === self.SelectedSchoolYear;
                    });
                }

                if (!self.SelectedCollege) {
                    // No specific record called for - default to selecting the first entry, which should be the "newest"
                    self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                }

                // Check if any of the term requests associated with the student have marked the college orientation as completed.
                // If at least one of them is completed, then we don't need to show missing orientation status.
                if (self.StudentCollegeInfo) {
                    self.HasCompletedOrientation = self.StudentCollegeInfo.some(term => term.CollegeID === self.SelectedCollege.CollegeID && term.CompletedOrientation === true);
                }
            } else {
                // No colleges available. Ensure that the selected college is nulled out, in case there was one
                // previously but it was just removed.
                self.SelectedCollege = null;
            }

            // Now that we possibly have a target college term request selected, how we continue depends on if
            // this is a student/parent, or other.
            return Observable.create(function (agreementObs: Observer<boolean>) {
                if (!self.User.IsParent && !self.User.IsStudent) {
                    // Not a parent or student, or no college selected. We can resolve the master observable.
                    agreementObs.next(true);
                    agreementObs.complete();
                } else {
                    // This is a parent or a student. If we do not have a selected college, we can resolve the master observable.
                    if (!self.SelectedCollege) {
                        agreementObs.next(true);
                        agreementObs.complete();
                    } else {
                        // We have a selected DE term request record. We need to now look to see if we have agreements
                        // on file for that entry.
                        // If none is found, we must load the entry and set up the record for getting approval.
                        // Otherwise, we can resolve the loading process.
                        const agreementsNeeded: StudentCollegeInfo[] = [];

                        if (self.SelectedCollege.HistoricalRecord !== true) {
                            // This selected college request is not for a historical record. Check for agreements.
                            if (
                                (!self.User.IsParent &&
                                    (!self.SelectedCollege.StudentCollegeAgreementApproved ||
                                        !self.SelectedCollege.StudentPolkAgreementApproved)) ||
                                (self.User.IsParent && self.SelectedCollege.ParentHasApproved !== true)
                            ) {
                                // No agreement on file. Load the agreement for this record.
                                agreementsNeeded.push(self.SelectedCollege);
                            }
                        }

                        if (agreementsNeeded.length > 0) {
                            // We now need to come up with college agreement text entries, and attach them to the term request record.
                            // Set up individual observables for each, then call out for the entries. Note: We will retrieve the
                            // PCSB text regardless of which college needs agreement.
                            const agreeObs = <Observable<CollegeAgreement>[]>[];

                            agreeObs.push(self.appService.GetCollegeAgreementText(self.User.AuthToken, 1)); // PCSB entry.

                            agreementsNeeded.forEach((item) => {
                                agreeObs.push(self.appService.GetCollegeAgreementText(self.User.AuthToken, item.CollegeID));
                            });

                            // Wait for all to resolve
                            zip(...agreeObs)
                                .pipe(takeUntil(self._subRelease))
                                .subscribe(
                                    (results) => {
                                        // Grab the matching master record in both the master StudentInfoList and FilteredStudentInfoList
                                        // which matches the college returned, and set the fields.
                                        if (results && !!results.length) {
                                            results.forEach((item) => {
                                                if (item.CollegeID === 1) {
                                                    // PCSB unique. Store it separately
                                                    self.PCSBAgreementText = item.Text;
                                                    self.PCSBAgreementDate = item.DateCreated;
                                                    self.PCSBAgreementConsentText = item.ConsentText;
                                                } else {
                                                    // Find the correct one matching this college ID
                                                    let stuFound = self.StudentCollegeInfo.filter((listitem) => {
                                                        return listitem.CollegeID === item.CollegeID;
                                                    });

                                                    if (stuFound && !!stuFound.length) {
                                                        stuFound.forEach((foundCol) => {
                                                            foundCol.AgreementText = item.Text;
                                                            foundCol.AgreementTextDate = item.DateCreated;
                                                            foundCol.AgreementConsentText = item.ConsentText;
                                                        });
                                                    }

                                                    stuFound = self.FilteredStudentCollegeInfo.filter((listitem) => {
                                                        return listitem.CollegeID === item.CollegeID;
                                                    });

                                                    if (stuFound && !!stuFound.length) {
                                                        stuFound.forEach((foundCol) => {
                                                            foundCol.AgreementText = item.Text;
                                                            foundCol.AgreementTextDate = item.DateCreated;
                                                            foundCol.AgreementConsentText = item.ConsentText;
                                                        });
                                                    }
                                                }
                                            });
                                        }

                                        self.AgreementChecks = <StudentAgreementsStatus>{};
                                        self.AgreementChecks.PCSBAgreed = false;
                                        self.AgreementChecks.CollegeAgreed = false;

                                        // Finally trigger the master obs
                                        agreementObs.next(true);
                                        agreementObs.complete();
                                    },
                                    (error) => {
                                        agreementObs.error(error);
                                    }
                                );
                        } else {
                            // No agreements needed. Resolve to continue.
                            agreementObs.next(true);
                            agreementObs.complete();
                        }
                    }
                }
            })
                .pipe(takeUntil(self._subRelease))
                .subscribe(
                    (ready) => {
                        // We can complete the process of loading student college info at this point, if it is warranted.
                        if (self.SelectedCollege && !self.User.IsParent) {
                            // We have a selected college and this is not a parent. We are ready to load courses.
                            // Check to see if we already have this college course set loaded.
                            const collegeLoadNeeded =
                                !self.SelectedCollegeCourses ||
                                !self.SelectedCollegeCourses.length ||
                                self.SelectedCollegeCourses[0].CollegeID !== self.SelectedCollege.CollegeID ||
                                self.SelectedCollegeCourses[0].SchoolYear !== self.SelectedCollege.CollegeSchoolYear;
                            const courseChoicesLoadNeeded =
                                !self.StudentSchedule ||
                                !self.StudentSchedule.length ||
                                self.StudentSchedule[0].DualEnrollStudentID !== self.SelectedCollege.DualEnrollStudentID;

                            const coursesObs = self.appService.GetAllCoursesAtCollege(
                                self.User.AuthToken,
                                self.SelectedCollege.CollegeID,
                                self.SelectedCollege.CollegeSchoolYear
                            );
                            const choicesObs = courseChoicesLoadNeeded
                                ? self.appService.GetStudentCourseChoices(
                                      self.User.AuthToken,
                                      self.SelectedCollege.DualEnrollStudentID
                                  )
                                : empty().pipe(startWith(self.StudentSchedule));

                            // Anyone other than the parent role can also retrieve any notes attached to the selected college.
                            // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                            const notesObs = !self.User.IsParent
                                ? courseChoicesLoadNeeded
                                    ? self.appService.GetStudentCollegeRecordNotes(
                                          self.User.AuthToken,
                                          self.SelectedCollege.DualEnrollStudentID
                                      )
                                    : empty().pipe(startWith(self.StudentScheduleNotes))
                                : empty().pipe(startWith(<CollegeRecordNote[]>null));

                            zip(coursesObs, choicesObs, notesObs, function (courses, choices, notes) {
                                return {
                                    CourseIndex: courses,
                                    Choices: choices,
                                    Notes: notes,
                                };
                            })
                                .pipe(takeUntil(self._subRelease))
                                .subscribe(
                                    (packet) => {
                                        self.SelectedCollegeDepartments =
                                            self.appService.CollegeCourses[packet.CourseIndex].Departments;
                                        self.SelectedCollegeCourses = self.appService.CollegeCourses[packet.CourseIndex].Courses;
                                        self.StudentScheduleNotes = packet.Notes;

                                        self.UpdateDesigneeRights();

                                        // Update the request list by resetting the scope variable
                                        self.UpdateRequestsInfo(packet.Choices, true);

                                        // Update the timeline step based upon the form state
                                        self.UpdateTimeline();

                                        // If we have a selected college now, update the url to ensure we're not the generic one any longer.
                                        const url = self.router
                                            .createUrlTree([
                                                '/studentview',
                                                self.SelectedCollege.DualEnrollStudentID,
                                                self.SelectedStudent.StudentID,
                                            ])
                                            .toString();
                                        self.location.go(url);

                                        finalObs.next(true);
                                        finalObs.complete();
                                    },
                                    (error) => {
                                        finalObs.error(error);
                                    }
                                );
                        } else {
                            // If we have a selected college now, update the url to ensure we're not the generic one any longer.
                            if (self.SelectedCollege) {
                                const url = self.router
                                    .createUrlTree([
                                        '/studentview',
                                        self.SelectedCollege.DualEnrollStudentID,
                                        self.SelectedStudent.StudentID,
                                    ])
                                    .toString();
                                self.location.go(url);
                            }

                            finalObs.next(true);
                            finalObs.complete();
                        }
                    },
                    (error) => {
                        finalObs.error(error);
                    }
                );
        });
    }

    // #endregion

    // #region Update Filtered List Method

    UpdateFilteredList(list: StudentCollegeInfo[], year: string) {
        const self = this;

        if (!list || !list.length) {
            self.FilteredStudentCollegeInfo = [];
            return;
        }

        if (!year) {
            self.FilteredStudentCollegeInfo = list.slice();
            return;
        }

        // Do we have an established parameter for a specific RecordID number? If so, we need to make sure we're using
        // that record's school year, in case it is different than the year passed in here. (Parameters always take precedence.)
        if (self.Params_RecordID != null) {
            const paramentry = list.find((item) => {
                return item.DualEnrollStudentID === self.Params_RecordID;
            });

            if (paramentry != null && paramentry.SchoolYear !== year) {
                // We may be potentially changing the school year being filtered. If this is a Fall term ('1'), and the year immediately
                // <strike this --> precedes or
                // succeeds the passed in school year, there's no reason to change the year.
                if (!paramentry.Term || paramentry.Term.TermCode !== '1' || !this.IsNextSchoolYear(year, paramentry.SchoolYear)) {
                    year = paramentry.SchoolYear;
                }
            }
        }

        // By design, filter into the list any term record with the matching year provided,
        // <scratch this--> or any whose term is '1'(Fall) and whose year immediately preceeds the school year,
        // or a term '1'(Fall) whose year immediate FOLLOWS the school year.
        let newList: StudentCollegeInfo[] = [];
        const lastYear = ('00' + (parseInt(year.substring(0, 2), 10) - 1)).slice(-2) + year.substring(0, 2);
        const nextYear = ('00' + parseInt(year.substr(2, 2), 10)).slice(-2) + ('00' + (parseInt(year.substr(2, 2), 10) + 1)).slice(-2);

        newList = list.filter((item) => {
            return (
                item.SchoolYear === year ||
                // (item.SchoolYear === lastYear && item.Term != null && item.Term.TermCode === '1') ||
                (item.SchoolYear === nextYear && item.Term != null && item.Term.TermCode === '1')
            );
        });

        self.FilteredStudentCollegeInfo = newList;
    }

    // #endregion

    // #region Update Requests Info Method

    UpdateRequestsInfo(requests: CourseChoice[], performMAC1105Check?: boolean) {
        const self = this;

        self.StudentSchedule = requests;

        // If we're supposed to perform the MAC 1105 check, we have some more work to do.
        // Is this on / before December 31, 2020, and the requests include the course MAC 1105, AND the current user is a school counselor
        // or school admin, AND the course is not yet scheduled, AND the form has not yet been submitted to the college advisor, pop up an
        // alert about it.
        const now = new Date();
        const deadline = new Date(2021, 0, 1);
        if (isBefore(now, deadline)) {
            // Is the current user a counselor or school admin (or developer for testing or district admin for verifying)?
            if (self.User.IsCounselor || self.User.IsSchoolAdmin || self.User.IsDeveloper || self.User.IsDistrictAdmin) {
                // Is the selected form already submitted?
                if (![5, 10].includes(self.SelectedCollege.FormStatus)) {
                    // Is MAC 1105 in the list of courses requested, as active/non-removed and not yet scheduled?
                    const foundCourses = (requests || []).filter(
                        (r) => r.Prefix === 'MAC' && r.Code === '1105' && r.DateRemoved == null && r.DateScheduled == null
                    );

                    if (foundCourses.length) {
                        // Pop alert.
                        self.dialogService
                            .OpenMessageBoxDialog({
                                TitleText: 'MAC 1105 Notice',
                                MessageText:
                                    `You have selected MAC 1105 College Algebra as part of this schedule. Students may not ` +
                                    `enroll in this course unless they have:<ul><li>earned a final grade of C or higher in MAT 1033,</li>` +
                                    `<li><strong>-or-</strong> earned a grade of B or higher in Precalculus,</li>` +
                                    `<li><strong>-or-</strong> earned a score of 510 or higher on the math portion of the PSAT.</li></ul>` +
                                    `<br /><br />Please verify the course requirements have been met prior to submitting ` +
                                    `this course request to the college for scheduling.`,
                                OKText: 'OK',
                            })
                            .subscribe();
                    }
                }
            }
        }
    }

    // #endregion

    // #region Update Student College Program Method

    UpdateStudentCollegeProgram(col: StudentProgramChange) {
        const self = this;

        // Check to make sure that we have both required components: A dual enrollment program selection,
        // and if necessary, an accelerated degree program. This is a failsafe as this shouldn't be called unless both are present.
        if (col.ProgramID == null) {
            self.splashService.SnackbarError('Please choose a Dual Enrollment Program.');
            return;
        }
        if (col.ProgramID === 3 && col.AcceleratedDegreeProgramID == null) {
            self.splashService.SnackbarError('Please choose an Accelerated Degree Program.');
            return;
        }

        // Wipe out the Accelerated Program ID if the selected ProgramID isn't 3 (which uses that child field).
        // This is in case it used to be 3/other and the person just changed it to something else.
        if (col.ProgramID !== 3) {
            col.AcceleratedDegreeProgramID = null;
        }

        // Send off the request to the system.
        const message = `You are about to change this student's Dual Enrollment Program choice as follows:<br /><br />
        <strong>New Program Choice:</strong> ${self.dualEnrollmentProgramPipe.transform(col.ProgramID)}${
            col.ProgramID === 3
                ? '<br /><strong>New Degree Program:</strong> ' +
                  self.acceleratedDegreeProgramPipe.transform(col.AcceleratedDegreeProgramID)
                : ''
        }<br /><br />
        <strong>Original Program Choice:</strong> ${self.dualEnrollmentProgramPipe.transform(col.OriginalProgramID)}${
            col.OriginalProgramID === 3
                ? '<br /><strong>Original Degree Program:</strong> ' +
                  self.acceleratedDegreeProgramPipe.transform(col.OriginalAcceleratedDegreeProgramID)
                : ''
        }<br /><br />Are you sure you wish to continue?`;

        // Get a confirmation.
        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: message,
                OKText: 'Yes - Change Program',
                CancelText: 'No - CANCEL',
            })
            .subscribe((result) => {
                if (result === true) {
                    // User has opted to continue. Call the server to process the setting.
                    self.appService
                        .UpdateStudentProgram(
                            self.User.AuthToken,
                            col.DualEnrollStudentID,
                            col.ProgramID,
                            col.AcceleratedDegreeProgramID
                        )
                        .subscribe(
                            (collegeinfo) => {
                                // Find the correct entry in the list of all known college data, then replace that entry with
                                // the one just returned, and update the SelectedCollege property.
                                if (self.StudentCollegeInfo && self.StudentCollegeInfo.length) {
                                    const entryIdx = self.StudentCollegeInfo.findIndex((item) => {
                                        return item.DualEnrollStudentID === collegeinfo.DualEnrollStudentID;
                                    });
                                    if (entryIdx >= 0) {
                                        self.StudentCollegeInfo[entryIdx] = collegeinfo;
                                        self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

                                        // Commented out for now since changing the program shouldn't necessarily force the currently
                                        // selected DE request to change? JGK 6/5/18
                                        // self.SelectedCollege = null;

                                        // self.UpdateFilteredList(self.StudentCollegeInfo, self.SelectedSchoolYear);

                                        // if (self.FilteredStudentCollegeInfo) {
                                        //     let entry = self.FilteredStudentCollegeInfo.find(item =>
                                        // {return item.DualEnrollStudentID == collegeinfo.DualEnrollStudentID;});
                                        //     self.SelectedCollege = entry;
                                        // }

                                        // if (!self.SelectedCollege && self.FilteredStudentCollegeInfo &&
                                        // self.FilteredStudentCollegeInfo.length) {
                                        //     self.SelectedCollege = self.FilteredStudentCollegeInfo[0];
                                        // }

                                        // self.UpdateDesigneeRights();
                                    }
                                }

                                // Toast the successful update
                                self.splashService.SnackbarSuccess('Dual Enrollment Program Update Successful.');

                                // Refresh/Load the courses for this college and term.
                                // Skipped because if we're not changing the currently selected DE term request, there's no reason
                                // to refresh the colleges courses.
                                // self.appService.GetAllCoursesAtCollege(self.User.AuthToken, self.SelectedCollege.CollegeID,
                                // self.SelectedCollege.CollegeSchoolYear)
                                //     .subscribe(
                                //         courseIdx => {
                                //             if (courseIdx != null) {
                                //                 self.SelectedCollegeDepartments = self.appService.CollegeCourses[courseIdx].Departments;
                                //                 self.SelectedCollegeCourses = self.appService.CollegeCourses[courseIdx].Courses;
                                //             }
                                //         },
                                //         error => {
                                //             self.errorService.HandleServiceError(error);
                                //         }
                                //     );

                                // // Update timeline
                                // self.UpdateTimeline();
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                        );
                } else {
                    // User canceled.
                }
            });
    }

    // #endregion

    // #region Update Timeline Step Method

    UpdateOrientationStatus(status: boolean) {
        const self = this;

        if (!self.SelectedCollege) {
            return;
        }

        // Get approval for this process
        self.dialogService
            .OpenConfirmationDialog({
                TitleText: 'Confirmation Requested',
                MessageText: `You are about to confirm the orientation completion status for ${
                    self.SelectedCollege.CollegeName
                }. Are you sure?`,
                OKText: 'Yes',
                CancelText: 'No - Cancel',
            }).subscribe((yes) => {
                if (yes === true) {

                    // Send this value to the database for updating.
                    self.appService
                        .UpdateStudentCompletedOrientation(
                            self.User.AuthToken,
                            self.SelectedCollege.DualEnrollStudentID,
                            self.SelectedStudent.StudentID,
                            self.SelectedCollege.CollegeID,
                            status,
                        )
                        .subscribe(
                            (success) => {
                                // Toast success.
                                self.splashService.SnackbarSuccess('College Orienation status updated successfully.');

                                // Update the currently selected college by setting the fast track to the proper value.
                                self.SelectedCollege.CompletedOrientation = success ? success.CompletedOrientation : self.SelectedCollege.CompletedOrientation;
                            },
                            (error) => {
                                self.errorService.HandleServiceError(error);
                            }
                    );

                    self.HasCompletedOrientation = true;
                }
            });
    }

    // #endregion

    // #region Update Timeline Step Method

    UpdateTimeline() {
        const self = this;

        if (!self.SelectedCollege) {
            return;
        }

        // Update the timeline step based upon the form state
        switch (self.SelectedCollege.FormStatus) {
            case 0:
            case 1:
                self.TimelineStep = 0;
                break; // No student agreement yet
            case 2:
                self.TimelineStep = 1;
                break; // No counselor program selection yet
            case 3:
                self.TimelineStep = 2;
                break; // Student picking courses
            case 4:
                // This depends on if the parent has agreed yet. If not, use that step (3). Otherwise, use the next one (4)
                if (self.SelectedCollege.ParentHasApproved !== true) {
                    self.TimelineStep = 3; // Waiting on parent agreement
                } else {
                    self.TimelineStep = 4; // Waiting on school admin
                }
                break;
            case 5:
                self.TimelineStep = 5;
                break; // Waiting on college advisor
            case 6:
                self.TimelineStep = 2;
                break; // Returned to school
            case 10:
                self.TimelineStep = 6;
                break; // All approved and done
        }
    }

    // #endregion

    // #region Update Single College Info Method

    UpdateSingleCollegeInfo(col: StudentCollegeInfo): Observable<any> {
        const self = this;

        // Does this record have a DualEnrollStudentID (meaning, is it an existing record in the system)?
        // If not, there's nothing to load/do here since it was a record in progress before the year switching took place.
        if (!col.DualEnrollStudentID) {
            return empty().pipe(startWith(null));
        }
        // Update boolean flag for school requiring orientation completion requirements
        self.RequiresOrientation = self.RequiredOrientationColleges.includes(col.CollegeID)

        // If the current role is any role other than a parent or student, we can skip agreements handling. Otherwise:
        // Does the student (or parent) have an agreement on file for this college record?
        // If not, we will need to load one instead of loading college information.
        if (
            self.User &&
            // col.SchoolYear == self.CurrentSchoolYear && (
            // Student
            ((self.User.IsStudent && (!col.StudentCollegeAgreementApproved || !col.StudentPolkAgreementApproved)) ||
                // Parent
                (self.User.IsParent && col.ParentHasApproved !== true))
        ) {
            // Load the college agreements for this entry.
            const pcsbObs = self.appService.GetCollegeAgreementText(self.User.AuthToken, 1); // PCSB entry.
            const colObs = self.appService.GetCollegeAgreementText(self.User.AuthToken, col.CollegeID);

            // Wait for all to resolve agreements to resolve out
            const result = zip(pcsbObs, colObs, function (PCSB, College) {
                return {
                    Polk: PCSB,
                    College: College,
                };
            }).pipe(takeUntil(self._subRelease));

            result.subscribe(
                (results) => {
                    // Parse through the array and link up the agreement text returned to the college objects
                    if (results && results.Polk) {
                        // PCSB unique. Store it separately
                        self.PCSBAgreementText = results.Polk.Text;
                        self.PCSBAgreementDate = results.Polk.DateCreated;
                        self.PCSBAgreementConsentText = results.Polk.ConsentText;
                    }

                    if (results && results.College) {
                        // Attach the agreement text to this entry
                        col.AgreementText = results.College.Text;
                        col.AgreementTextDate = results.College.DateCreated;
                        col.AgreementConsentText = results.College.ConsentText;
                    }

                    self.AgreementChecks = <StudentAgreementsStatus>{};
                    self.AgreementChecks.PCSBAgreed = !self.User.IsParent ? col.StudentPolkAgreementApproved : col.ParentHasApproved;
                    self.AgreementChecks.CollegeAgreed = !self.User.IsParent
                        ? col.StudentCollegeAgreementApproved
                        : col.ParentHasApproved;
                },
                (error) => {
                    // Toss an error
                    self.errorService.HandleServiceError(error);
                }
            );

            return result;
        } else {
            // No agreements loading necessary. Complete the updating by loading courses for the college and the student's
            // schedule requests for the term involved, if this is not a parent.
            self.SelectedCollege = col;

            if (!self.User.IsParent) {
                // We have a selected college, and we are ready to load courses. Check to see if we already have this
                // college course set loaded.
                const coursesObs = self.appService.GetAllCoursesAtCollege(
                    self.User.AuthToken,
                    self.SelectedCollege.CollegeID,
                    self.SelectedCollege.CollegeSchoolYear
                );
                // Also need to now request the student's schedule of desired classes at this college and term.
                const choicesObs = self.appService.GetStudentCourseChoices(
                    self.User.AuthToken,
                    self.SelectedCollege.DualEnrollStudentID
                );

                // Non-parent roles will also load internal notes.
                // UPDATE: IIQ #T-875493, Everyone can now see Notes section, except parents due to FERPA regulations. - EE 2026-09-10
                const notesObs = !self.User.IsParent
                    ? self.appService.GetStudentCollegeRecordNotes(self.User.AuthToken, self.SelectedCollege.DualEnrollStudentID)
                    : empty().pipe(startWith(<CollegeRecordNote[]>null));

                const result = zip(coursesObs, choicesObs, notesObs, function (courses, choices, notes) {
                    return {
                        CourseIndex: courses,
                        Choices: choices,
                        Notes: notes,
                    };
                }).pipe(takeUntil(self._subRelease));

                result.subscribe(
                    (packet) => {
                        self.SelectedCollegeDepartments = self.appService.CollegeCourses[packet.CourseIndex].Departments;
                        self.SelectedCollegeCourses = self.appService.CollegeCourses[packet.CourseIndex].Courses;
                        self.StudentScheduleNotes = packet.Notes;

                        self.UpdateDesigneeRights();

                        // Update the request list by resetting the scope variable
                        self.UpdateRequestsInfo(packet.Choices, true);

                        // And update the timeline
                        self.UpdateTimeline();
                    },
                    (error) => {
                        self.errorService.HandleServiceError(error);
                    }
                );

                return result;
            } else {
                // Return a faked out result.
            }
        }
    }

    // #endregion
}



// WEBPACK FOOTER //
// ./src/app/requests/requests.component.ts